import * as i0 from '@angular/core';
import { NgModule, InjectionToken, Injectable, Inject, Optional, Component, EventEmitter, Output, Input, ViewChild, Pipe, ContentChildren } from '@angular/core';
import * as i2$1 from '@angular/common';
import { CommonModule, NgIf } from '@angular/common';
import * as i2 from '@angular/common/http';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { defaults as defaults$1, ScaleLine } from 'ol/control';
import { defaults, Modify, Translate, Snap } from 'ol/interaction';
import VectorLayer from 'ol/layer/Vector';
import OlMap from 'ol/Map';
import { addProjection, get, transform } from 'ol/proj';
import Projection from 'ol/proj/Projection';
import VectorSource from 'ol/source/Vector';
import CircleStyle from 'ol/style/Circle';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import Style, { createEditingStyle, createDefaultStyle } from 'ol/style/Style';
import View from 'ol/View';
import { unByKey } from 'ol/Observable';
import { BehaviorSubject, Subject, ReplaySubject, noop } from 'rxjs';
import { distinctUntilChanged, map, shareReplay } from 'rxjs/operators';
import GeoJSON from 'ol/format/GeoJSON';
import Cluster from 'ol/source/Cluster';
import ImageLayer from 'ol/layer/Image';
import { ImageStatic, TileWMS } from 'ol/source';
import TileLayer from 'ol/layer/Tile';
import WMTS, { optionsFromCapabilities } from 'ol/source/WMTS';
import WMTSTileGrid from 'ol/tilegrid/WMTS';
import { applyStyle } from 'ol-mapbox-style';
import { getTopLeft } from 'ol/extent';
import Feature from 'ol/Feature';
import { MVT, WMSCapabilities, GeoJSON as GeoJSON$1 } from 'ol/format';
import VectorTileLayer from 'ol/layer/VectorTile';
import VectorTileSource from 'ol/source/VectorTile';
import TileGrid from 'ol/tilegrid/TileGrid';
import ImageWMS from 'ol/source/ImageWMS';
import WMTSCapabilities from 'ol/format/WMTSCapabilities';
import { Collection } from 'ol';
import { never } from 'ol/events/condition';
import Draw, { createBox } from 'ol/interaction/Draw';
import { Point } from 'ol/geom';
import LineString from 'ol/geom/LineString';
import Polygon from 'ol/geom/Polygon';
import { Text, Icon } from 'ol/style';
import MousePosition from 'ol/control/MousePosition';
import WKT from 'ol/format/WKT';

class DrawInteractionModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: DrawInteractionModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.3", ngImport: i0, type: DrawInteractionModule, imports: [CommonModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: DrawInteractionModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: DrawInteractionModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [],
                }]
        }] });

const DEFAULT_MAP = "_DEFAULT_";
const EXTRA_LAYERS = new InjectionToken("EXTRA_LAYERS");
const ZOOM_OPTIONS = new InjectionToken("ZOOM_OPTIONS");
const ROTATE_OPTIONS = new InjectionToken("ROTATE_OPTIONS");
const ATTRIBUTION_OPTIONS = new InjectionToken("ATTRIBUTION_OPTIONS");

const extent = [-285401.92, 22598.08, 595401.92, 903401.92];
const resolutions = [
    3440.64, 1720.32, 860.16, 430.08, 215.04, 107.52, 53.76, 26.88, 13.44, 6.72,
    3.36, 1.68, 0.84, 0.42, 0.21, 0.105, 0.0525, 0.02625, 0.013125, 0.0065625,
    0.00328125, 0.001640625, 0.000820313, 0.000410156, 0.000205078, 0.000102539,
];
const defs = "+proj=sterea +lat_0=52.15616055555555 +lon_0=5.38763888888889 +k=0.9999079 +x_0=155000 +y_0=463000 +ellps=bessel +towgs84=565.417,50.3319,465.552,-0.398957,0.343988,-1.8774,4.0725 +units=m +no_defs";
const matrixSizes = [
    1, 2, 4, 8, 16, 32, 64, 128, 256, 512, 1024, 2048, 4096, 8192, 16384, 32768,
    65536, 131072, 262144, 524288, 1048576, 2097152, 4194304, 8388608, 16777216,
    33554432,
];
const epsg28992 = "EPSG:28992";
const matrixIds = resolutions.map((_, i) => `${epsg28992}:${i}`);

class CrsConfigService {
    static { this.MAX_ZOOMLEVEL = 25; }
    getRdNewCrsConfig() {
        if (this.rdNewCrsConfig === undefined) {
            this.rdNewCrsConfig = {
                projectionCode: epsg28992,
                extent,
                resolutions,
                matrixSet: epsg28992,
                matrixIds,
                matrixSizes,
                units: "m",
            };
        }
        return this.rdNewCrsConfig;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: CrsConfigService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: CrsConfigService, providedIn: "root" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: CrsConfigService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }] });

var MapComponentEventTypes;
(function (MapComponentEventTypes) {
    MapComponentEventTypes["MAPINITIALIZED"] = "mapInitialized";
    MapComponentEventTypes["ZOOMEND"] = "zoomEnd";
    MapComponentEventTypes["ZOOMENDLOCATION"] = "zoomEndLocation";
    MapComponentEventTypes["SINGLECLICK"] = "singleClick";
    MapComponentEventTypes["WMSCAPABILITIES"] = "WmsCapabilities";
    MapComponentEventTypes["WMSFEATUREINFO"] = "WmsFeatureInfo";
    MapComponentEventTypes["WMTSCAPABILITES"] = "WmtsCapabilites";
    MapComponentEventTypes["WMTSFEATUREINFO"] = "WmtsFeatureInfo";
    MapComponentEventTypes["VECTORFEATUREINFO"] = "vectorFeatureInfo";
    MapComponentEventTypes["GEOJSONFEATUREINFO"] = "geoJsonFeatureInfo";
    MapComponentEventTypes["SUCCESSFUL"] = "successful";
    MapComponentEventTypes["UNSUCCESSFUL"] = "unsuccessful";
    MapComponentEventTypes["LOADING"] = "loading";
    MapComponentEventTypes["SELECTIONSERVICE_MAPCLICKED"] = "selectionServiceMapClicked";
    MapComponentEventTypes["SELECTIONSERVICE_CLEARSELECTION"] = "selectionServiceClearSelection";
    MapComponentEventTypes["SELECTIONSERVICE_SELECTIONUPDATED"] = "selectionServiceSelectionUpdated";
})(MapComponentEventTypes || (MapComponentEventTypes = {}));
class MapComponentEvent {
    // type: MapComponentEventTypes; // singleClick, zoomEnd, ...
    // mapName: string; // naam van de map
    // layerName: string // naam van de layer, alleen wanneer het event door een ggc-layer component wordt gegooid
    // message: string; // de gebruiker heeft op een button geklikt, het zoomen is beeindingd, ...
    // value?: any; // optioneel, het oorspronkelijke event indien aanwezig
    constructor(type, mapName, message, layerName, value) {
        this.type = type;
        this.mapName = mapName;
        this.message = message;
        this.layerName = layerName;
        this.value = value;
    }
}
class MapViewState {
    constructor(center, zoom) {
        this.center = center;
        this.zoom = zoom;
    }
}

class ObservableMapWrapper {
    constructor(create) {
        this.map = new Map();
        this.create = create;
    }
    get size() {
        return this.map.size;
    }
    getOrCreate(name) {
        if (!this.map.has(name)) {
            const subject = this.create();
            this.map.set(name, { subject, observable: subject.asObservable() });
        }
        return this.map.get(name);
    }
    getOrCreateSubject(name) {
        const map = this.getOrCreate(name);
        return map.subject;
    }
    getOrCreateObservable(name) {
        const map = this.getOrCreate(name);
        return map.observable;
    }
    get(name) {
        return this.map.get(name);
    }
    has(name) {
        return this.map.has(name);
    }
    delete(name) {
        return this.map.delete(name);
    }
}

class CoreLoadingService {
    constructor() {
        this.eventsMap = new Map();
        this.loadCounter = new Map();
        this.loadStatesMap = new ObservableMapWrapper(() => new BehaviorSubject(false));
    }
    addMapLoaders(mapIndex, map) {
        const loadstart = map.on("loadstart", () => {
            this.loadStatesMap.getOrCreateSubject(mapIndex).next(true);
        });
        const loadend = map.on("loadend", () => {
            this.loadStatesMap.getOrCreateSubject(mapIndex).next(false);
        });
        this.eventsMap.set(mapIndex, [loadstart, loadend]);
    }
    removeMapLoaders(mapIndex) {
        const events = this.eventsMap.get(mapIndex);
        if (events) {
            events.forEach((key) => unByKey(key));
        }
    }
    destroyLoadersForMap(mapIndex) {
        this.loadCounter.delete(mapIndex);
        this.loadStatesMap.delete(mapIndex);
    }
    isLoading(mapIndex) {
        return this.loadStatesMap
            .getOrCreateObservable(mapIndex)
            .pipe(distinctUntilChanged());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: CoreLoadingService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: CoreLoadingService, providedIn: "root" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: CoreLoadingService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }] });

class CoreMapService {
    constructor(crsConfigService, coreLoadingService, zoomOptions, rotateOptions, attributionOptions) {
        this.crsConfigService = crsConfigService;
        this.coreLoadingService = coreLoadingService;
        this.zoomOptions = zoomOptions;
        this.rotateOptions = rotateOptions;
        this.attributionOptions = attributionOptions;
        this.olMaps = new Map();
        this.extraLayers = ["selection", "highlight"];
        this.extraLayersMap = new Map();
        this.rdNewConfig = this.crsConfigService.getRdNewCrsConfig();
        this.rdNewProjection = new Projection({
            code: this.rdNewConfig.projectionCode,
            extent: this.rdNewConfig.extent,
            units: this.rdNewConfig.units,
            // workaround for showing correct scale in scaleLineComponent
            // https://github.com/openlayers/openlayers/issues/7309#issuecomment-343433613
            getPointResolution(resolution) {
                return resolution;
            },
        });
        addProjection(this.rdNewProjection);
    }
    createAndGetMap(mapIndex, minZoomLevel = 0, maxZoomLevel = 14) {
        // this method create a map and sets number of resolutions,
        // should only be called once from map.component.ts
        mapIndex = mapIndex ?? DEFAULT_MAP;
        if (!this.olMaps.has(mapIndex)) {
            // create a new map and drawlayer for this map
            this.olMaps.set(mapIndex, this.createNewOlMap());
        }
        const map = this.olMaps.get(mapIndex);
        map.setView(new View({
            projection: this.rdNewProjection,
            resolutions: this.rdNewConfig.resolutions.slice(0, maxZoomLevel + 1),
            center: [160000, 455000],
        }));
        // call setMinZoom after the view is created, because according to the documentation minZoom is ignored
        // if resolutions is set in ViewOptions
        // see: https://openlayers.org/en/latest/apidoc/module-ol_View-View.html
        map.getView().setMinZoom(Math.floor(minZoomLevel));
        this.coreLoadingService.addMapLoaders(mapIndex, map);
        this.createExtraLayers(mapIndex);
        return map;
    }
    createLayerAndAddToMap(mapIndex, style) {
        const vectorSource = new VectorSource();
        const vectorLayer = new VectorLayer({
            source: vectorSource,
            style,
        });
        // add layer as an un-managed layer, the un-managed layer will always be on top.
        // https://openlayers.org/en/v5.3.0/apidoc/module-ol_layer_Layer-Layer.html#setMap
        const map = this.getMap(mapIndex);
        vectorLayer.setMap(map);
        return vectorLayer;
    }
    getMap(mapIndex) {
        mapIndex = mapIndex ?? DEFAULT_MAP;
        if (!this.olMaps.has(mapIndex)) {
            this.olMaps.set(mapIndex, this.createNewOlMap());
        }
        return this.olMaps.get(mapIndex);
    }
    getLayer(layerId, mapIndex = DEFAULT_MAP) {
        const map = this.getMap(mapIndex);
        return map
            .getLayers()
            .getArray()
            .find((layer) => layer.get("ggc-layer-id") === layerId);
    }
    getExtraLayer(layer, mapIndex = DEFAULT_MAP) {
        return this.extraLayersMap.get(`${mapIndex}-${layer}`);
    }
    checkMapIndex(mapIndex = DEFAULT_MAP) {
        mapIndex = mapIndex ?? DEFAULT_MAP;
        return this.olMaps.has(mapIndex);
    }
    destroyMap(mapIndex) {
        this.olMaps.delete(mapIndex);
        this.extraLayers.forEach((layer) => {
            this.extraLayersMap.delete(`${mapIndex}-${layer}`);
        });
        this.coreLoadingService.removeMapLoaders(mapIndex);
    }
    decideMapComponentEventType(mapExists, mapIndex) {
        const mapName = mapIndex ?? DEFAULT_MAP;
        if (mapExists) {
            return new MapComponentEvent(MapComponentEventTypes.SUCCESSFUL, mapName, "Methode succesvol uitgevoerd");
        }
        return new MapComponentEvent(MapComponentEventTypes.UNSUCCESSFUL, mapName, `Mapindex bestaat niet voor index: ${mapName}`);
    }
    addFeaturesToHighlightLayer(features, mapIndex) {
        if (this.checkMapIndex(mapIndex)) {
            // We know for sure that the selectionLayer exists, checkMapIndex indirectly checks that
            const highlightLayerSource = this.getHighlightLayerSource(mapIndex);
            highlightLayerSource.addFeatures(features);
            return this.decideMapComponentEventType(true, mapIndex);
        }
        return this.decideMapComponentEventType(false, mapIndex);
    }
    clearHighlightLayer(mapIndex) {
        if (this.checkMapIndex(mapIndex)) {
            const highlightLayerSource = this.getHighlightLayerSource(mapIndex);
            if (highlightLayerSource) {
                highlightLayerSource.clear();
            }
            return this.decideMapComponentEventType(true, mapIndex);
        }
        return this.decideMapComponentEventType(false, mapIndex);
    }
    changeHighlightLayerStyle(styleLike, mapIndex) {
        this.changeLayerStyle(styleLike, mapIndex, "highlight");
    }
    addFeaturesToSelectionLayer(features, mapIndex) {
        if (this.checkMapIndex(mapIndex)) {
            // We know for sure that the selectionLayer exists, checkMapIndex indirectly checks that
            const selectionSource = this.getSelectionLayerSource(mapIndex);
            selectionSource.addFeatures(features);
            return this.decideMapComponentEventType(true, mapIndex);
        }
        return this.decideMapComponentEventType(false, mapIndex);
    }
    clearSelectionLayer(mapIndex) {
        if (this.checkMapIndex(mapIndex)) {
            // We know for sure that the selectionLayer exists, checkMapIndex indirectly checks that
            const selectionLayerSource = this.getSelectionLayerSource(mapIndex);
            selectionLayerSource.clear();
            return this.decideMapComponentEventType(true, mapIndex);
        }
        return this.decideMapComponentEventType(false, mapIndex);
    }
    changeSelectionLayerStyle(styleLike, mapIndex) {
        this.changeLayerStyle(styleLike, mapIndex, "selection");
    }
    changeLayerStyle(styleLike, mapIndex, layername) {
        const layer = this.extraLayersMap.get(`${mapIndex}-${layername}`);
        layer?.setStyle(styleLike);
    }
    setExtraLayers(layers) {
        this.extraLayers = [...this.extraLayers, ...layers];
    }
    createNewOlMap() {
        return new OlMap({
            controls: this.getControls(),
            interactions: defaults({
                // Is always set to false because of the interaction with the tabindex if it's provided.
                // If no tabindex is provided, it does nothing.
                onFocusOnly: false,
            }),
            layers: [],
            view: new View({
                projection: this.rdNewProjection,
            }),
        });
    }
    getControls() {
        const zoomOptions = this.zoomOptions || undefined;
        const rotateOptions = this.rotateOptions || undefined;
        const attributionOptions = this.attributionOptions || undefined;
        if (zoomOptions?.zoomInLabel instanceof HTMLElement) {
            zoomOptions.zoomInLabel = this.clone(zoomOptions.zoomInLabel);
        }
        if (zoomOptions?.zoomOutLabel instanceof HTMLElement) {
            zoomOptions.zoomOutLabel = this.clone(zoomOptions.zoomOutLabel);
        }
        if (rotateOptions?.label instanceof HTMLElement) {
            rotateOptions.label = this.clone(rotateOptions.label);
        }
        if (attributionOptions?.label instanceof HTMLElement) {
            attributionOptions.label = this.clone(attributionOptions.label);
        }
        if (attributionOptions?.collapseLabel instanceof HTMLElement) {
            attributionOptions.collapseLabel = this.clone(attributionOptions.collapseLabel);
        }
        return defaults$1({ rotateOptions, zoomOptions, attributionOptions });
    }
    clone(element) {
        return element.cloneNode(true);
    }
    getHighlightLayerSource(mapIndex) {
        return this.extraLayersMap.get(`${mapIndex}-highlight`)?.getSource();
    }
    getSelectionLayerSource(mapIndex) {
        return this.extraLayersMap.get(`${mapIndex}-selection`)?.getSource();
    }
    createExtraLayers(mapIndex) {
        // Order in which the selection- and highlightlayer are created is important!
        // The selection layer should be added to the map before the highlight layer is added.
        this.extraLayers.forEach((layername) => {
            const layer = this.createLayerAndAddToMap(mapIndex, new Style());
            this.extraLayersMap.set(`${mapIndex}-${layername}`, layer);
        });
        this.setDefaultHighlightLayerStyle(mapIndex);
        this.setDefaultSelectionLayerStyle(mapIndex);
    }
    setDefaultHighlightLayerStyle(mapIndex) {
        const highlightStyle = new Style({
            fill: new Fill({
                color: "rgba(0, 115, 149, 0.5)",
            }),
            stroke: new Stroke({
                color: "#007395",
                width: 5,
            }),
            image: new CircleStyle({
                radius: 7,
                fill: new Fill({
                    color: "rgba(0, 115, 149, 0.5)",
                }),
                stroke: new Stroke({
                    color: "#007395",
                    width: 5,
                }),
            }),
        });
        const layer = this.extraLayersMap.get(`${mapIndex}-highlight`);
        layer?.setStyle(highlightStyle);
    }
    setDefaultSelectionLayerStyle(mapIndex) {
        const fill = new Fill({
            color: "rgba(255,255,255,0.5)",
        });
        const stroke = new Stroke({
            color: "#0093be",
            width: 4,
        });
        const selectionStyle = new Style({
            fill,
            stroke,
            image: new CircleStyle({
                fill,
                stroke,
                radius: 5,
            }),
        });
        const layer = this.extraLayersMap.get(`${mapIndex}-selection`);
        layer?.setStyle(selectionStyle);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: CoreMapService, deps: [{ token: CrsConfigService }, { token: CoreLoadingService }, { token: ZOOM_OPTIONS, optional: true }, { token: ROTATE_OPTIONS, optional: true }, { token: ATTRIBUTION_OPTIONS, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: CoreMapService, providedIn: "root" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: CoreMapService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: function () { return [{ type: CrsConfigService }, { type: CoreLoadingService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [ZOOM_OPTIONS]
                }, {
                    type: Optional
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [ROTATE_OPTIONS]
                }, {
                    type: Optional
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [ATTRIBUTION_OPTIONS]
                }, {
                    type: Optional
                }] }]; } });

class FeatureCollectionForLayer {
}
class FeatureCollectionForCoordinate {
    constructor(coord) {
        this.coordinate = coord;
        this.featureCollectionForLayers = [];
    }
}
// CurrentAndPreviousSelection niet exporteren in public api, want dit is een intern model.
// Wordt niet doorgegeven aan de afnemers van het component.
class CurrentAndPreviousSelection {
}

var SelectionModeTypes;
(function (SelectionModeTypes) {
    SelectionModeTypes["SINGLE_SELECT"] = "singleselect";
    SelectionModeTypes["MULTI_SELECT"] = "multiselect";
})(SelectionModeTypes || (SelectionModeTypes = {}));

class CoreSelectionService {
    constructor() {
        this.selectionModeMap = new Map();
        this.allSelections = new Map();
        // subject for emitting events and observable for subscribing to events. An observable cannot emit events.
        this.subjectMap = new Map();
        this.observableMap = new Map();
    }
    static { this.messageClearSelection = "Selectie is gewist"; }
    static { this.messageMapClicked = "Er is geklikt in de kaart en de feature info wordt opgehaald."; }
    static { this.messageSelectionUpdated = "Nieuwe feature info van een kaartlaag toegevoegd aan de selectie."; }
    static { this.messageCoordinateDoesNotMatch = "Er is iets mis gegaan in de CoreSelectionService: het coordinaat van de kaartlaag komt" +
        " niet overeen met het verwachte coordinaat van het klik-event in de kaart."; }
    destroySelectionForMap(mapIndex) {
        if (this.subjectMap.has(mapIndex)) {
            this.observableMap.delete(mapIndex);
            this.subjectMap.delete(mapIndex);
        }
        this.selectionModeMap.delete(mapIndex);
        this.allSelections.delete(mapIndex);
    }
    setSelectionModeForMapName(singleSelect, mapIndex) {
        // 'set' adds the key+value or updates the value when the key already exists
        this.selectionModeMap.set(mapIndex, singleSelect);
    }
    isMultiSelectMode(mapIndex) {
        if (this.selectionModeMap.has(mapIndex)) {
            return (this.selectionModeMap.get(mapIndex) === SelectionModeTypes.MULTI_SELECT);
        }
        return false;
    }
    getObservableForMap(mapIndex) {
        this.createIfNotExistsSubjectAndObservableForMap(mapIndex);
        return this.observableMap.get(mapIndex);
    }
    clearSelectionForMap(mapIndex) {
        this.allSelections.set(mapIndex, new CurrentAndPreviousSelection());
        this.emitEvent(mapIndex, new MapComponentEvent(MapComponentEventTypes.SELECTIONSERVICE_CLEARSELECTION, mapIndex, CoreSelectionService.messageClearSelection));
    }
    setSelectionForLayer(features, layerName, mapIndex) {
        const currentAndPreviousSelection = this.getAllSelectionsForMap(mapIndex);
        const currentSelection = currentAndPreviousSelection.current ||
            new FeatureCollectionForCoordinate();
        const featureCollection = currentSelection.featureCollectionForLayers.find((i) => i.layerName === layerName);
        if (featureCollection) {
            featureCollection.features = features;
        }
        else {
            currentSelection.featureCollectionForLayers.push({ layerName, features });
        }
        currentAndPreviousSelection.current = currentSelection;
        this.emitEvent(mapIndex, new MapComponentEvent(MapComponentEventTypes.SELECTIONSERVICE_SELECTIONUPDATED, mapIndex, CoreSelectionService.messageMapClicked, layerName, currentAndPreviousSelection.current));
    }
    handleSingleclickEventForMap(coordinate, mapIndex) {
        const currentAndPreviousSelection = this.getAllSelectionsForMap(mapIndex);
        if (this.isMultiSelectMode(mapIndex)) {
            currentAndPreviousSelection.previous =
                currentAndPreviousSelection.current;
        }
        currentAndPreviousSelection.current = new FeatureCollectionForCoordinate(coordinate);
        this.emitEvent(mapIndex, new MapComponentEvent(MapComponentEventTypes.SELECTIONSERVICE_MAPCLICKED, mapIndex, CoreSelectionService.messageMapClicked, undefined, currentAndPreviousSelection.current));
    }
    clearFeatureInfoForLayer(mapIndex, layerName) {
        const currentAndPreviousSelection = this.getAllSelectionsForMap(mapIndex);
        const currentSelection = currentAndPreviousSelection.current;
        if (currentSelection == null) {
            return;
        }
        const featureCollection = currentSelection.featureCollectionForLayers.find((i) => i.layerName === layerName);
        if (featureCollection) {
            currentSelection.featureCollectionForLayers =
                currentSelection.featureCollectionForLayers.filter((obj) => obj !== featureCollection);
        }
        // emit the event async by calling it from setTimeout
        setTimeout(() => {
            this.emitEvent(mapIndex, new MapComponentEvent(MapComponentEventTypes.SELECTIONSERVICE_SELECTIONUPDATED, mapIndex, CoreSelectionService.messageSelectionUpdated, layerName, currentAndPreviousSelection.current));
        });
    }
    handleFeatureInfoForLayer(mapIndex, coordinate, features, layerName) {
        const currentAndPreviousSelection = this.getAllSelectionsForMap(mapIndex);
        const currentSelection = currentAndPreviousSelection.current;
        if (currentSelection && currentSelection.coordinate === coordinate) {
            if (this.isMultiSelectMode(mapIndex)) {
                // multiselect
                let layerInPreviousSelection;
                if (currentAndPreviousSelection.previous) {
                    // als er een vorige selectie was, zoeken of de vorige kaartlaag voorkwam in de selectie
                    layerInPreviousSelection =
                        currentAndPreviousSelection.previous.featureCollectionForLayers.find((layerselection) => layerselection.layerName === layerName);
                }
                if (layerInPreviousSelection) {
                    // in de vorige selectie is de kaartlaag aanwezig, dus controleren of features al geselecteerd waren
                    const multiSelectFeatures = this.getMultiSelectFeatures(layerInPreviousSelection.features, features);
                    currentSelection.featureCollectionForLayers.push({
                        layerName,
                        features: multiSelectFeatures,
                    });
                }
                else {
                    // kaartlaag niet aanwezig in vorige selectie, dus toegevoegen aan nieuwe selectie
                    currentSelection.featureCollectionForLayers.push({
                        layerName,
                        features,
                    });
                }
            }
            else {
                // singleselect, altijd de nieuwe features toevoegen aan de selectie
                currentSelection.featureCollectionForLayers.push({
                    layerName,
                    features,
                });
            }
            this.emitEvent(mapIndex, new MapComponentEvent(MapComponentEventTypes.SELECTIONSERVICE_SELECTIONUPDATED, mapIndex, CoreSelectionService.messageSelectionUpdated, layerName, currentAndPreviousSelection.current));
        }
        else {
            this.emitEvent(mapIndex, new MapComponentEvent(MapComponentEventTypes.UNSUCCESSFUL, mapIndex, CoreSelectionService.messageCoordinateDoesNotMatch));
        }
    }
    getMultiSelectFeatures(previousFeatures, features) {
        const multiSelectFeatures = previousFeatures; // eerst vorige selectie overnemen
        features.forEach((f) => {
            const indexFound = previousFeatures.findIndex((prevF) => prevF.getId() === f.getId());
            if (indexFound < 0) {
                // feature was nog niet geselecteerd, dus toevoegen aan selectie
                multiSelectFeatures.unshift(f);
            }
            else {
                // feature was al geselecteerd, dus verwijderen uit selectie
                multiSelectFeatures.splice(indexFound, 1);
            }
        });
        return multiSelectFeatures;
    }
    createIfNotExistsSubjectAndObservableForMap(mapName) {
        if (!this.subjectMap.has(mapName)) {
            this.subjectMap.set(mapName, new Subject());
            this.observableMap.set(mapName, this.subjectMap.get(mapName).asObservable());
        }
    }
    getAllSelectionsForMap(mapIndex) {
        if (this.allSelections.has(mapIndex)) {
            return this.allSelections.get(mapIndex);
        }
        return this.allSelections
            .set(mapIndex, new CurrentAndPreviousSelection())
            .get(mapIndex);
    }
    emitEvent(mapIndex, event) {
        this.createIfNotExistsSubjectAndObservableForMap(mapIndex);
        this.subjectMap.get(mapIndex).next(event);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: CoreSelectionService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: CoreSelectionService, providedIn: "root" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: CoreSelectionService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }] });

class AbstractBaseLayerComponent {
    constructor(injector) {
        this.injector = injector;
        this.mapName = DEFAULT_MAP;
        this.coreMapService = injector.get(CoreMapService);
        this.coreSelectionService = injector.get(CoreSelectionService);
        this.crsConfig = injector.get(CrsConfigService);
    }
    ngOnInit() {
        this.rdNewConfig = this.crsConfig.getRdNewCrsConfig();
        if (this.options?.mapName !== undefined) {
            this.mapName = this.options.mapName;
        }
    }
    ngOnDestroy() {
        // remove the layer if the tag is destroyed.
        if (this.map !== undefined && this.olLayer !== undefined) {
            this.map.removeLayer(this.olLayer);
        }
    }
    setLayer(layer) {
        this.olLayer = layer;
        this.map = this.coreMapService.getMap(this.mapName);
        this.map.addLayer(this.olLayer);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: AbstractBaseLayerComponent, deps: [{ token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.3", type: AbstractBaseLayerComponent, selector: "ng-component", ngImport: i0, template: "", isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: AbstractBaseLayerComponent, decorators: [{
            type: Component,
            args: [{
                    template: "",
                }]
        }], ctorParameters: function () { return [{ type: i0.Injector }]; } });

class CoreMapEventsService {
    constructor(coreLoadingServiceService) {
        this.coreLoadingServiceService = coreLoadingServiceService;
        this.singleclickMap = new ObservableMapWrapper(() => new Subject());
        // ReplaySubject for zoomend, because it doesn't have an initial value and emits the last value on subscribing
        this.zoomendMap = new ObservableMapWrapper(() => new ReplaySubject(1));
    }
    destroyEventsForMap(mapName) {
        this.destroySingleclickForMap(mapName);
        this.destroyZoomendForMap(mapName);
    }
    // should only be called from map.component.ts
    emitSingleclickEventForMap(evt, mapName) {
        this.singleclickMap.getOrCreateSubject(mapName).next(evt);
    }
    getSingleclickObservableForMap(mapName) {
        return this.singleclickMap.getOrCreateObservable(mapName);
    }
    destroySingleclickForMap(mapName) {
        this.singleclickMap.delete(mapName);
    }
    // should only be called from map.component.ts
    emitZoomendEventForMap(evt, mapName) {
        this.zoomendMap.getOrCreateSubject(mapName).next(evt);
    }
    getZoomendObservableForMap(mapName) {
        return this.zoomendMap.getOrCreateObservable(mapName);
    }
    destroyZoomendForMap(mapName) {
        this.zoomendMap.delete(mapName);
    }
    getLoadingObservableForMap(mapName) {
        return this.coreLoadingServiceService.isLoading(mapName);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: CoreMapEventsService, deps: [{ token: CoreLoadingService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: CoreMapEventsService, providedIn: "root" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: CoreMapEventsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: function () { return [{ type: CoreLoadingService }]; } });

class AbstractConfigurableLayerComponent extends AbstractBaseLayerComponent {
    constructor(injector) {
        super(injector);
        this.injector = injector;
        this.events = new EventEmitter();
    }
    ngOnInit() {
        super.ngOnInit();
        this.layerName = this.options?.layerName;
        this.attributions = this.options?.attributions;
        this.layerOptions = {
            ...(this.options?.minResolution && {
                minResolution: this.options?.minResolution,
            }),
            ...(this.options?.maxResolution && {
                maxResolution: this.options?.maxResolution,
            }),
            ...(this.options?.zIndex && { zIndex: this.options?.zIndex }),
        };
    }
    ngOnDestroy() {
        super.ngOnDestroy();
    }
    setLayer(layer) {
        super.setLayer(layer);
        this.olLayer.set("ggc-layer-id", this.options?.layerId);
        const attributions = this.options?.attributions;
        if (attributions !== undefined) {
            this.olLayer.getSource().setAttributions(attributions);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: AbstractConfigurableLayerComponent, deps: [{ token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.3", type: AbstractConfigurableLayerComponent, selector: "ggc-abstract-configurable-layer", outputs: { events: "events" }, usesInheritance: true, ngImport: i0, template: "", isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: AbstractConfigurableLayerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: "ggc-abstract-configurable-layer",
                    template: "",
                }]
        }], ctorParameters: function () { return [{ type: i0.Injector }]; }, propDecorators: { events: [{
                type: Output
            }] } });

class AbstractClickableLayerComponent extends AbstractConfigurableLayerComponent {
    constructor(injector) {
        super(injector);
        this.injector = injector;
        this.maxFeaturesOnSingleclick = 8;
        this.mapEventsService = injector.get(CoreMapEventsService);
    }
    ngOnInit() {
        super.ngOnInit();
        if (this.options?.getFeatureInfoOnSingleclick === true) {
            this.singleclick = this.mapEventsService
                .getSingleclickObservableForMap(this.mapName)
                .subscribe((evt) => {
                this.getFeatureInfo(evt);
            });
        }
        if (this.options?.maxFeaturesOnSingleclick !== undefined) {
            this.maxFeaturesOnSingleclick = this.options?.maxFeaturesOnSingleclick;
        }
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        // unsubscribe on singleclick
        if (this.singleclick !== undefined) {
            this.singleclick.unsubscribe();
        }
        if (this.options?.getFeatureInfoOnSingleclick === true && this.layerName) {
            this.coreSelectionService.clearFeatureInfoForLayer(this.mapName, this.layerName);
        }
    }
    getFeatureInfo(_event) {
        // stubbed method
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: AbstractClickableLayerComponent, deps: [{ token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.3", type: AbstractClickableLayerComponent, selector: "ng-component", usesInheritance: true, ngImport: i0, template: "", isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: AbstractClickableLayerComponent, decorators: [{
            type: Component,
            args: [{
                    template: "",
                }]
        }], ctorParameters: function () { return [{ type: i0.Injector }]; } });

class GeojsonLayerComponent extends AbstractClickableLayerComponent {
    constructor(injector) {
        super(injector);
        this.injector = injector;
        this.foundFeatures = [];
    }
    ngOnInit() {
        super.ngOnInit();
        this.geoJsonFormat = new GeoJSON({
            dataProjection: this.rdNewConfig.projectionCode,
            geometryName: "",
            featureProjection: this.rdNewConfig.projectionCode,
        });
        const options = {
            ...this.options?.sourceOptions,
            ...(this.options?.url && { url: this.options?.url }),
            ...(this.options?.features && { features: this.options?.features }),
            format: this.geoJsonFormat,
        };
        this.vectorSource = new VectorSource(options);
        const layerOptions = {
            ...this.options?.layerOptions,
            ...this.layerOptions,
            ...(this.options?.styleLike && { style: this.options?.styleLike }),
        };
        if (this.options?.clusterDistance !== undefined ||
            this.options?.sourceClusterOptions !== undefined) {
            this.clusterSource = new Cluster({
                ...this.options?.sourceClusterOptions,
                ...(this.options?.clusterDistance && {
                    distance: this.options?.clusterDistance,
                }),
                ...(this.attributions && { attributions: this.attributions }),
                source: this.vectorSource,
            });
            layerOptions.source = this.clusterSource;
        }
        else {
            layerOptions.source = this.vectorSource;
        }
        this.setLayer(new VectorLayer(layerOptions));
    }
    ngOnChanges(changes) {
        if (changes.url && !changes.url.firstChange) {
            this.updateUrl(changes.url.currentValue);
        }
        if (changes.features && !changes.features.firstChange) {
            this.updateFeatures(changes.features.currentValue);
        }
        if (changes.options && !changes.options.firstChange) {
            if (changes.options.currentValue.sourceOptions?.url !==
                changes.options.previousValue?.sourceOptions?.url) {
                this.updateUrl(changes.options.currentValue.sourceOptions?.url);
            }
            if (changes.options.currentValue.url !== changes.options.previousValue?.url) {
                this.updateUrl(changes.options.currentValue.url);
            }
            if (changes.options.currentValue.sourceOptions?.features !==
                changes.options.previousValue?.sourceOptions?.features) {
                this.updateFeatures(changes.options.currentValue.sourceOptions?.features);
            }
            if (changes.options.currentValue.features !==
                changes.options.previousValue?.features) {
                this.updateFeatures(changes.options.currentValue.features);
            }
        }
    }
    updateUrl(url) {
        const vectorSource = this.olLayer.getSource();
        vectorSource.setUrl(url);
        vectorSource.refresh();
    }
    updateFeatures(features) {
        let vectorSource = this.olLayer.getSource();
        if (vectorSource instanceof Cluster) {
            vectorSource = vectorSource.getSource();
        }
        vectorSource.clear();
        vectorSource.addFeatures(features);
    }
    getFeatureInfo(event) {
        const pixel = event.pixel;
        this.map.forEachFeatureAtPixel(pixel, (feature) => this.limitFeatures(feature), {
            layerFilter: (layerCandidate) => this.decideLayerCandidate(layerCandidate),
            hitTolerance: this.options?.hitTolerance,
        });
        /* Kopie van de foundFeatures meegeven, omdat dit anders later fout gaat met
         de objectreferentie bij het zetten van foundFeatures.length op 0. */
        const foundFeaturesCopy = this.foundFeatures.slice();
        if (this.layerName) {
            this.coreSelectionService.handleFeatureInfoForLayer(this.mapName, event.coordinate, foundFeaturesCopy, this.layerName);
        }
        const mapComponentEvent = new MapComponentEvent(MapComponentEventTypes.GEOJSONFEATUREINFO, this.mapName, "GeoJSON getFeatureInfo resultaten: ", this.layerName, foundFeaturesCopy);
        this.events.emit(mapComponentEvent);
        this.foundFeatures.length = 0;
    }
    limitFeatures(feature) {
        if (this.foundFeatures.length < this.maxFeaturesOnSingleclick) {
            // feature as Feature, because VectorSource contains Features. RenderFeatures are used for VectorTileLayer
            this.foundFeatures.push(feature);
        }
    }
    decideLayerCandidate(layerCandidate) {
        return (layerCandidate instanceof VectorLayer &&
            ((layerCandidate.getSource() instanceof Cluster &&
                layerCandidate.getSource().getSource().getUrl() ===
                    this.vectorSource.getUrl()) ||
                layerCandidate.getSource().getUrl() === this.vectorSource.getUrl()));
    }
    ngOnDestroy() {
        super.ngOnDestroy();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: GeojsonLayerComponent, deps: [{ token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.3", type: GeojsonLayerComponent, selector: "ggc-geojson-layer", inputs: { options: "options" }, usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "", isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: GeojsonLayerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: "ggc-geojson-layer",
                    template: "",
                }]
        }], ctorParameters: function () { return [{ type: i0.Injector }]; }, propDecorators: { options: [{
                type: Input
            }] } });

class ImageLayerComponent extends AbstractConfigurableLayerComponent {
    ngOnInit() {
        super.ngOnInit();
        this.imageSource = new ImageStatic({
            // url is not optional in ImageStatic options, but can be set from options or input which can both be undefined.
            url: "",
            crossOrigin: "anonymous",
            ...this.options?.sourceOptions,
            // only set url when this.options.url is defined, otherwise it will overwrite url from this.options?.sourceOptions
            ...(this.options?.url && { url: this.options?.url }),
            ...(this.options?.imageExtent && {
                imageExtent: this.options?.imageExtent,
            }),
            projection: this.rdNewConfig.projectionCode,
        });
        this.setLayer(new ImageLayer({
            ...this.options?.layerOptions,
            ...this.layerOptions,
            source: this.imageSource,
        }));
    }
    ngOnDestroy() {
        super.ngOnDestroy();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: ImageLayerComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.3", type: ImageLayerComponent, selector: "ggc-image-layer", inputs: { options: "options" }, usesInheritance: true, ngImport: i0, template: "", isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: ImageLayerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: "ggc-image-layer",
                    template: "",
                }]
        }], propDecorators: { options: [{
                type: Input
            }] } });

class LayerBrtAchtergrondkaartComponent extends AbstractBaseLayerComponent {
    constructor(injector) {
        super(injector);
        this.injector = injector;
    }
    ngOnInit() {
        super.ngOnInit();
        const brtsource = new WMTS({
            projection: this.rdNewConfig.projectionCode,
            layer: "standaard",
            format: "image/png",
            url: "https://service.pdok.nl/brt/achtergrondkaart/wmts/v2_0?",
            matrixSet: this.rdNewConfig.matrixSet,
            style: "default",
            crossOrigin: "anonymous",
            tileGrid: new WMTSTileGrid({
                extent: this.rdNewConfig.extent,
                resolutions: this.rdNewConfig.resolutions,
                matrixIds: this.rdNewConfig.matrixIds,
            }),
        });
        this.setLayer(new TileLayer({
            source: brtsource,
            minResolution: 0.21, // set minResolution because brtachtergrondkaart is not available for smaller resolutions
        }));
        this.olLayer.set("ggc-layer-id", "ggc-brtachtergrondkaart");
    }
    ngOnDestroy() {
        super.ngOnDestroy();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: LayerBrtAchtergrondkaartComponent, deps: [{ token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.3", type: LayerBrtAchtergrondkaartComponent, selector: "ggc-layer-brt-achtergrondkaart", inputs: { mapName: "mapName" }, usesInheritance: true, ngImport: i0, template: "", isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: LayerBrtAchtergrondkaartComponent, decorators: [{
            type: Component,
            args: [{
                    selector: "ggc-layer-brt-achtergrondkaart",
                    template: "",
                }]
        }], ctorParameters: function () { return [{ type: i0.Injector }]; }, propDecorators: { mapName: [{
                type: Input
            }] } });

class VectorTileLayerComponent extends AbstractClickableLayerComponent {
    constructor(injector) {
        super(injector);
        this.injector = injector;
        this.tileSize = [256, 256];
        this.foundFeatures = [];
    }
    ngOnInit() {
        super.ngOnInit();
        const options = {
            format: new MVT({ featureClass: Feature }),
            ...this.options?.sourceOptions,
            ...(this.attributions && { attributions: this.attributions }),
            ...(this.options?.url && { url: this.options?.url }),
            projection: this.crsConfig.getRdNewCrsConfig().projectionCode,
            tileGrid: new TileGrid({
                resolutions: this.crsConfig.getRdNewCrsConfig().resolutions,
                extent: this.crsConfig.getRdNewCrsConfig().extent,
                tileSize: this.tileSize || this.options?.tileSize || [256, 256],
                origin: getTopLeft(this.crsConfig.getRdNewCrsConfig().extent),
            }),
        };
        this.vectorTileSource = new VectorTileSource(options);
        const vectorTileLayer = new VectorTileLayer({
            renderMode: "hybrid",
            declutter: true,
            useInterimTilesOnError: false,
            ...this.options?.layerOptions,
            ...this.layerOptions,
            source: this.vectorTileSource,
        });
        // Set style before adding layer preventing flickering
        this.setStyle(vectorTileLayer);
        this.setLayer(vectorTileLayer);
    }
    getFeatureInfo(event) {
        const pixel = event.pixel;
        this.map.forEachFeatureAtPixel(pixel, (feature) => this.limitFeatures(feature), {
            hitTolerance: this.hitTolerance || this.options?.hitTolerance,
        });
        const foundFeaturesCopy = this.foundFeatures.slice();
        if (this.layerName) {
            this.coreSelectionService.handleFeatureInfoForLayer(this.mapName, event.coordinate, foundFeaturesCopy, this.layerName);
        }
        const mapComponentEvent = new MapComponentEvent(MapComponentEventTypes.VECTORFEATUREINFO, this.mapName, "VectorTileLayer getFeatureInfo resultaten: ", this.layerName, foundFeaturesCopy);
        this.events.emit(mapComponentEvent);
        this.foundFeatures = [];
    }
    limitFeatures(feature) {
        if (this.foundFeatures.length < this.maxFeaturesOnSingleclick) {
            // feature as Feature, because VectorTileSource contains Features. RenderFeatures are used for VectorTileLayer
            this.foundFeatures.push(feature);
        }
    }
    async loadStyle(url) {
        try {
            const glStyle = await fetch(url);
            const json = await glStyle.json();
            Object.keys(json.sources).forEach((key) => {
                applyStyle(this.olLayer, json, key);
            });
        }
        catch (e) {
            console.error(`Failed to load style from ${url}`);
        }
    }
    setStyle(layer) {
        if (typeof this.style === "string" ||
            typeof this.options?.style === "string") {
            this.loadStyle(this.style || this.options?.style);
        }
        else {
            layer.setStyle(this.style || this.options?.style || this.options?.layerOptions?.style);
        }
    }
    ngOnDestroy() {
        super.ngOnDestroy();
    }
    ngOnChanges(changes) {
        if (changes.style && this.olLayer) {
            this.setStyle(this.olLayer);
        }
        if (changes.options && !changes.options.firstChange) {
            if (this.options?.layerOptions?.style !==
                changes.options.previousValue.layerOptions?.style) {
                this.setStyle(this.olLayer);
            }
            if (this.options?.style !== changes.options.previousValue.style) {
                this.setStyle(this.olLayer);
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: VectorTileLayerComponent, deps: [{ token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.3", type: VectorTileLayerComponent, selector: "ggc-vector-tile-layer", inputs: { hitTolerance: "hitTolerance", tileSize: "tileSize", style: "style", options: "options" }, usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "", isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: VectorTileLayerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: "ggc-vector-tile-layer",
                    template: "",
                }]
        }], ctorParameters: function () { return [{ type: i0.Injector }]; }, propDecorators: { hitTolerance: [{
                type: Input
            }], tileSize: [{
                type: Input
            }], style: [{
                type: Input
            }], options: [{
                type: Input
            }] } });

class CoreCapabilitiesService {
    constructor(coreMapService, httpClient) {
        this.coreMapService = coreMapService;
        this.httpClient = httpClient;
        this.capabilitiesMap = new Map();
    }
    getCapabilitiesForUrl(baseUrl, service, withCredentials = false) {
        let format;
        const params = {
            request: "getCapabilities",
            service,
        };
        if (service === "WMTS") {
            format = new WMTSCapabilities();
        }
        else {
            format = new WMSCapabilities();
            params.version = "1.3.0";
        }
        if (this.capabilitiesMap.has(baseUrl)) {
            return this.capabilitiesMap.get(baseUrl);
        }
        else {
            const observable = this.httpClient
                .get(baseUrl, {
                responseType: "text",
                params,
                withCredentials,
            })
                .pipe(map((res) => {
                return format.read(res);
            }), shareReplay(1));
            this.capabilitiesMap.set(baseUrl, observable);
            return observable;
        }
    }
    optionsFromCapabilities(wmtsCapabilities, config) {
        return optionsFromCapabilities(wmtsCapabilities, config);
    }
    hasFeatureInfoUrl(capabilities) {
        return !!capabilities.getFeatureInfoUrl();
    }
    createGetFeatureInfoUrlObservable(baseUrl, source, coordinate, resolution) {
        const baseParams = this.constructGetFeatureInfoParams(source, coordinate, resolution);
        return this.httpClient.get(baseUrl, { params: baseParams });
    }
    constructGetFeatureInfoParams(source, coordinate, resolution) {
        const tileGrid = source.getTileGrid();
        // haalt het TileCoord (zoom, x, y) op voor het coordinaat en de resolutie
        const tileCoord = tileGrid.getTileCoordForCoordAndResolution(coordinate, resolution);
        const tileCol = tileCoord[1];
        const tileRow = tileCoord[2];
        // haalt het extent van de TileCoord op
        const tileExtent = tileGrid.getTileCoordExtent(tileCoord);
        const tileResolution = tileGrid.getResolution(tileCoord[0]);
        const zoom = tileGrid.getZForResolution(tileResolution);
        const i = Math.floor((coordinate[0] - tileExtent[0]) / tileResolution);
        const j = Math.floor((tileExtent[3] - coordinate[1]) / tileResolution);
        return {
            SERVICE: "WMTS",
            VERSION: "1.0.0",
            REQUEST: "GetFeatureInfo",
            LAYER: source.getLayer(),
            STYLE: "",
            FORMAT: "image/png",
            TileCol: "" + tileCol,
            TileRow: "" + tileRow,
            TileMatrix: source.getMatrixSet() + ":" + zoom,
            TileMatrixSet: source.getMatrixSet(),
            I: "" + i,
            J: "" + j,
            infoformat: "application/json",
            info_format: "application/json",
            FEATURE_COUNT: "8",
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: CoreCapabilitiesService, deps: [{ token: CoreMapService }, { token: i2.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: CoreCapabilitiesService, providedIn: "root" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: CoreCapabilitiesService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: function () { return [{ type: CoreMapService }, { type: i2.HttpClient }]; } });

const viewResolutionIsInLayerResolutionRange = (viewResolution, minResolution, maxResolution) => {
    // First check if minResolution exists && check if viewResolution is greather than or equal to minResolution
    const minResCheck = minResolution
        ? viewResolution >= minResolution
        : true;
    // Check if maxResolution exists && check if viewResolution is smaller than maxResolution
    const maxResCheck = maxResolution
        ? viewResolution < maxResolution
        : true;
    // ViewResolution is in range (=return true) when both previous checks are true
    return minResCheck && maxResCheck;
};

class WmsLayerComponent extends AbstractClickableLayerComponent {
    constructor(injector) {
        super(injector);
        this.injector = injector;
        this.capabilitiesService = injector.get(CoreCapabilitiesService);
        this.httpClient = injector.get(HttpClient);
    }
    ngOnInit() {
        super.ngOnInit();
        const urlForCapabilities = this.options?.url || this.options?.sourceOptions?.url;
        if (this.options?.getCapabilities !== false && urlForCapabilities) {
            this.capabilitiesService
                .getCapabilitiesForUrl(urlForCapabilities, "WMS", this.options?.sourceOptions?.crossOrigin === "withCredentials")
                .subscribe((result) => {
                this.events.emit(new MapComponentEvent(MapComponentEventTypes.WMSCAPABILITIES, this.mapName, "WMS capabilities resultaten:", this.layerName, result));
            }, noop);
        }
        const params = {
            ...this.options?.sourceOptions?.params,
            ...(this.options?.layers && { layers: this.options?.layers }),
        };
        // Pixelratio conform openlayers
        // https://github.com/openlayers/openlayers/blob/main/src/ol/source/ImageArcGISRest.js#L247
        if (window.devicePixelRatio !== 1) {
            const dpi = Math.floor(90 * window.devicePixelRatio + 0.5);
            params.DPI = dpi;
            params.MAP_RESOLUTION = dpi;
        }
        const sourceOptions = {
            // deze instelling dwingt af dat de server Access-Control-Allow-Origin:*
            // in de header mee terug stuurt, anders wordt de WMS niet getoond
            crossOrigin: "anonymous",
            serverType: "geoserver",
            ...this.options?.sourceOptions,
            params,
            ...(this.options?.url && { url: this.options?.url }),
            projection: this.rdNewConfig.projectionCode,
        };
        const layerOptions = {
            ...this.options?.layerOptions,
            ...this.layerOptions,
        };
        if (this.options?.tiled) {
            if (this.options?.gutter) {
                // set gutter to prevent that icons and labels are clipped at the edges of the tiles.
                sourceOptions.gutter = this.options.gutter;
            }
            this.wmsSource = new TileWMS(sourceOptions);
            layerOptions.source = this.wmsSource;
            this.setLayer(new TileLayer(layerOptions));
        }
        else {
            this.wmsSource = new ImageWMS(sourceOptions);
            layerOptions.source = this.wmsSource;
            this.setLayer(new ImageLayer(layerOptions));
        }
    }
    getFeatureInfo(evt) {
        const coordinate = evt.coordinate;
        const viewResolution = this.map.getView().getResolution();
        if (viewResolution &&
            viewResolutionIsInLayerResolutionRange(viewResolution, this.olLayer.getMinResolution(), this.olLayer.getMaxResolution())) {
            const querylayers = this.options?.getFeatureInfoQueryLayers ||
                this.options?.layers ||
                this.options?.sourceOptions?.params?.layers;
            const featureInfoUrl = this.wmsSource.getFeatureInfoUrl(coordinate, viewResolution, this.rdNewConfig.projectionCode, {
                INFO_FORMAT: "application/json",
                // query_layers lijkt voor sommige wms-en nodig
                QUERY_LAYERS: querylayers,
                FEATURE_COUNT: this.maxFeaturesOnSingleclick,
            });
            if (featureInfoUrl !== undefined) {
                this.httpClient.get(featureInfoUrl).subscribe((data) => {
                    const formatGeoJSON = new GeoJSON();
                    const features = formatGeoJSON.readFeatures(data);
                    this.emitFeatureInfoEvent(features, coordinate);
                }, (error) => {
                    this.emitFeatureInfoEvent([], coordinate, "Kon geen features ophalen van featureInfoUrl vanwege " +
                        error.statusText);
                });
            }
            else {
                this.emitFeatureInfoEvent([], coordinate, "Geen featureInfoUrl gevonden");
            }
        }
        else {
            this.emitFeatureInfoEvent([], coordinate, "Binnen deze resolutie zijn er geen features gevonden.");
        }
    }
    ngOnDestroy() {
        super.ngOnDestroy();
    }
    emitFeatureInfoEvent(features, coordinate, message = "WMS getFeatureInfo resultaten: ") {
        if (this.layerName) {
            this.coreSelectionService.handleFeatureInfoForLayer(this.mapName, coordinate, features, this.layerName);
        }
        this.events.emit(new MapComponentEvent(MapComponentEventTypes.WMSFEATUREINFO, this.mapName, message, this.layerName, features));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: WmsLayerComponent, deps: [{ token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.3", type: WmsLayerComponent, selector: "ggc-wms-layer", inputs: { options: "options" }, usesInheritance: true, ngImport: i0, template: "", isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: WmsLayerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: "ggc-wms-layer",
                    template: "",
                }]
        }], ctorParameters: function () { return [{ type: i0.Injector }]; }, propDecorators: { options: [{
                type: Input
            }] } });

class Capabilities {
    constructor(cap) {
        this.setFeatureInfoUrl(cap);
    }
    getFeatureInfoUrl() {
        return this.featureInfoUrl;
    }
    setFeatureInfoUrl(cap) {
        this.featureInfoUrl =
            cap?.OperationsMetadata?.GetFeatureInfo?.DCP?.HTTP?.Get &&
                cap.OperationsMetadata.GetFeatureInfo.DCP.HTTP.Get.length > 0 &&
                cap.OperationsMetadata.GetFeatureInfo.DCP.HTTP.Get["0"]?.href;
    }
}

class WmtsLayerComponent extends AbstractClickableLayerComponent {
    constructor(injector) {
        super(injector);
        this.injector = injector;
        this.capabilitiesService = injector.get(CoreCapabilitiesService);
    }
    ngOnInit() {
        super.ngOnInit();
        this.capabilitiesSubscription = this.capabilitiesService
            .getCapabilitiesForUrl(this.options?.url ||
            this.options?.sourceOptions?.url, "WMTS")
            .subscribe((result) => {
            if (result) {
                this.capabilities = new Capabilities(result);
                const options = this.capabilitiesService.optionsFromCapabilities(result, {
                    format: "image/png",
                    style: "default",
                    crossOrigin: "anonymous",
                    ...this.options?.sourceOptions,
                    ...(this.options?.layer && { layer: this.options?.layer }),
                    projection: this.rdNewConfig.projectionCode,
                });
                if (options) {
                    // Set transition to 0 when opacity < 1 to prevent flicker
                    const opacity = this.options?.opacity || this.options?.layerOptions?.opacity;
                    if (opacity !== undefined && opacity < 1) {
                        options.transition = 0;
                        this.layerOptions.opacity = opacity;
                    }
                    this.wmtsSource = new WMTS(options);
                    this.setLayer(new TileLayer({
                        ...this.options?.layerOptions,
                        ...this.layerOptions,
                        source: this.wmtsSource,
                    }));
                }
                else {
                    this.capabilities = undefined;
                    console.error("Could not generate options from capabilities");
                }
                this.events.emit(new MapComponentEvent(MapComponentEventTypes.WMTSCAPABILITES, this.mapName, "WMTS capabilities resultaten: ", this.layerName, result));
            }
            else {
                this.capabilities = undefined;
                console.error("Invalid capabilities");
            }
        });
    }
    getFeatureInfo(evt) {
        const coordinate = evt.coordinate;
        const viewResolution = this.map.getView().getResolution();
        if (viewResolution &&
            viewResolutionIsInLayerResolutionRange(viewResolution, this.olLayer.getMinResolution(), this.olLayer.getMaxResolution())) {
            if (this.capabilities &&
                this.capabilitiesService.hasFeatureInfoUrl(this.capabilities)) {
                const featureInfoObservable = this.capabilitiesService.createGetFeatureInfoUrlObservable(this.options?.url ||
                    this.options?.sourceOptions?.url, this.wmtsSource, coordinate, viewResolution);
                featureInfoObservable.subscribe((data) => {
                    const formatGeoJSON = new GeoJSON();
                    const features = formatGeoJSON.readFeatures(data);
                    this.emitFeatureInfoEvent(features, coordinate);
                }, () => {
                    this.emitFeatureInfoEvent([], coordinate);
                });
            }
            else {
                this.emitFeatureInfoEvent([], coordinate);
            }
        }
        else {
            this.emitFeatureInfoEvent([], coordinate);
        }
    }
    emitFeatureInfoEvent(features, coordinate) {
        if (this.layerName) {
            this.coreSelectionService.handleFeatureInfoForLayer(this.mapName, coordinate, features, this.layerName);
        }
        this.events.emit(new MapComponentEvent(MapComponentEventTypes.WMTSFEATUREINFO, this.mapName, "WMTS getFeatureInfo resultaten: ", this.layerName, features));
    }
    ngOnDestroy() {
        if (this.capabilitiesSubscription !== undefined) {
            this.capabilitiesSubscription.unsubscribe();
        }
        super.ngOnDestroy();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: WmtsLayerComponent, deps: [{ token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.3", type: WmtsLayerComponent, selector: "ggc-wmts-layer", inputs: { options: "options" }, usesInheritance: true, ngImport: i0, template: "", isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: WmtsLayerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: "ggc-wmts-layer",
                    template: "",
                }]
        }], ctorParameters: function () { return [{ type: i0.Injector }]; }, propDecorators: { options: [{
                type: Input
            }] } });

const layerTypes = [
    GeojsonLayerComponent,
    ImageLayerComponent,
    LayerBrtAchtergrondkaartComponent,
    VectorTileLayerComponent,
    WmsLayerComponent,
    WmtsLayerComponent,
];
class LayerModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: LayerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.3", ngImport: i0, type: LayerModule, declarations: [GeojsonLayerComponent,
            ImageLayerComponent,
            LayerBrtAchtergrondkaartComponent,
            VectorTileLayerComponent,
            WmsLayerComponent,
            WmtsLayerComponent, AbstractClickableLayerComponent,
            AbstractBaseLayerComponent,
            AbstractConfigurableLayerComponent], imports: [CommonModule, HttpClientModule], exports: [GeojsonLayerComponent,
            ImageLayerComponent,
            LayerBrtAchtergrondkaartComponent,
            VectorTileLayerComponent,
            WmsLayerComponent,
            WmtsLayerComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: LayerModule, imports: [CommonModule, HttpClientModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: LayerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        ...layerTypes,
                        AbstractClickableLayerComponent,
                        AbstractBaseLayerComponent,
                        AbstractConfigurableLayerComponent,
                    ],
                    imports: [CommonModule, HttpClientModule],
                    exports: [...layerTypes],
                }]
        }] });

class LoaderComponent {
    set mapName(value) {
        this._mapName = value;
        this.subscribe();
    }
    constructor(mapEventsService) {
        this.mapEventsService = mapEventsService;
        this.isLoading = false;
    }
    ngOnDestroy() {
        this.unsubscribe();
    }
    subscribe() {
        this.unsubscribe();
        this.loadEvents$ = this.mapEventsService
            .getLoadingObservableForMap(this._mapName)
            .subscribe((isLoading) => (this.isLoading = isLoading));
    }
    unsubscribe() {
        if (this.loadEvents$) {
            this.loadEvents$.unsubscribe();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: LoaderComponent, deps: [{ token: CoreMapEventsService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.3", type: LoaderComponent, selector: "ggc-loader", inputs: { mapName: "mapName" }, ngImport: i0, template: "<span class=\"ggc-loader fa-spin fas fa-spinner\" *ngIf=\"isLoading\"></span>\n", styles: [".ggc-loader{display:inline-flex}\n"], dependencies: [{ kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: LoaderComponent, decorators: [{
            type: Component,
            args: [{ selector: "ggc-loader", template: "<span class=\"ggc-loader fa-spin fas fa-spinner\" *ngIf=\"isLoading\"></span>\n", styles: [".ggc-loader{display:inline-flex}\n"] }]
        }], ctorParameters: function () { return [{ type: CoreMapEventsService }]; }, propDecorators: { mapName: [{
                type: Input
            }] } });

class LoaderModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: LoaderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.3", ngImport: i0, type: LoaderModule, declarations: [LoaderComponent], imports: [CommonModule], exports: [LoaderComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: LoaderModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: LoaderModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [LoaderComponent],
                    imports: [CommonModule],
                    exports: [LoaderComponent],
                }]
        }] });

class MapDetailsContainerComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: MapDetailsContainerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.3", type: MapDetailsContainerComponent, selector: "ggc-map-details-container", ngImport: i0, template: "<div #mapDetailsContainer class=\"ggc-map-details-container\">\n  <ng-content></ng-content>\n</div>\n", styles: [".ggc-map-details-container{display:inline-block}::ng-deep .ggc-mouse-position,::ng-deep .ggc-scale-denominator,::ng-deep .ggc-scale-line,::ng-deep .ggc-zoom-level{display:inline-block;float:left;position:relative;margin-right:10px}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: MapDetailsContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: "ggc-map-details-container", template: "<div #mapDetailsContainer class=\"ggc-map-details-container\">\n  <ng-content></ng-content>\n</div>\n", styles: [".ggc-map-details-container{display:inline-block}::ng-deep .ggc-mouse-position,::ng-deep .ggc-scale-denominator,::ng-deep .ggc-scale-line,::ng-deep .ggc-zoom-level{display:inline-block;float:left;position:relative;margin-right:10px}\n"] }]
        }] });

class MapDetailsContainerModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: MapDetailsContainerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.3", ngImport: i0, type: MapDetailsContainerModule, declarations: [MapDetailsContainerComponent], exports: [MapDetailsContainerComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: MapDetailsContainerModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: MapDetailsContainerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [MapDetailsContainerComponent],
                    exports: [MapDetailsContainerComponent],
                }]
        }] });

const white = [255, 255, 255, 1];
const svgColorWhite = "#fff";
const svgColorGrey = "#666666";
const labelTextStyle = new Text({
    fill: new Fill({
        color: white,
    }),
    padding: [5, 6, 5, 5],
    offsetY: -25,
});
const segmentLabelTextStyle = new Text({
    fill: new Fill({
        color: svgColorGrey,
    }),
    padding: [5, 6, 5, 5],
    offsetY: -25,
});
const labelImageStyle = new Icon({
    src: URL.createObjectURL(new Blob([getLabelSvg(svgColorGrey, svgColorGrey)], {
        type: "image/svg+xml",
    })),
});
const segmentLabelImageStyle = new Icon({
    src: URL.createObjectURL(new Blob([getLabelSvg(svgColorWhite, svgColorGrey)], {
        type: "image/svg+xml",
    })),
});
const segmentLengthStyle = new Style({
    text: segmentLabelTextStyle.clone(),
    image: segmentLabelImageStyle.clone(),
});
const lengthStyle = new Style({
    text: labelTextStyle.clone(),
    image: labelImageStyle.clone(),
});
const areaStyle = new Style({
    text: labelTextStyle.clone(),
    image: labelImageStyle.clone(),
});
const styleLabelFunction = (feature, measureStyle) => {
    const point = feature.getGeometry()?.getType() === "Polygon"
        ? new Point(feature.getGeometry().getInteriorPoint().getCoordinates())
        : new Point(feature.getGeometry().getLastCoordinate());
    const labelText = calculateDistanceOrArea(feature);
    const style = measureStyle.clone();
    style.getText().setText(labelText);
    style.setGeometry(point);
    return style;
};
const styleLengthLabelFunction = (feature, measureStyle) => {
    const geom = feature.getGeometry();
    let coord = geom.getLastCoordinate();
    let labelText;
    if (geom.getType() === "Polygon") {
        let length = 0;
        const coords = geom.getCoordinates()[0];
        coord = coords.reduce((previousValue, currentValue) => {
            if (previousValue) {
                const line = new LineString([previousValue, currentValue]);
                length += line.getLength();
            }
            return currentValue;
        });
        if (coords.length > 1) {
            coord = coords[coords.length - 2];
        }
        labelText = lengthToString(length);
    }
    else {
        labelText = calculateLength(geom);
    }
    const point = new Point(coord);
    const style = measureStyle.clone();
    style.getText().setText(labelText);
    style.setGeometry(point);
    return style;
};
const styleAreaLabelFunction = (feature, measureStyle) => {
    const point = new Point([0, 0]);
    let labelText = "";
    if (feature.getGeometry()?.getType() === "Polygon") {
        const poly = feature.getGeometry();
        point.setCoordinates(poly.getInteriorPoint().getCoordinates());
        labelText = calculateArea(poly);
    }
    else {
        point.setCoordinates(feature.getGeometry().getLastCoordinate());
    }
    const style = measureStyle.clone();
    style.getText().setText(labelText);
    style.setGeometry(point);
    return style;
};
const measuringStyleFunction = (feature) => {
    const defaultStyles = createEditingStyle();
    return defaultStyles[feature.getGeometry().getType()];
};
const finishedStyleFunction = (feature, resolution) => {
    return createDefaultStyle(feature, resolution);
};
const styleSegmentLabelFunction = (feature, segmentStyle) => {
    const geom = feature.getGeometry();
    const labels = [];
    if (geom instanceof LineString) {
        geom.forEachSegment((start, end) => {
            labels.push(getSegmentLabel(start, end, segmentStyle));
        });
    }
    else if (geom instanceof Polygon) {
        geom
            .getCoordinates()[0]
            .forEach((current, index, array) => {
            if (index > 0) {
                labels.push(getSegmentLabel(array[index - 1], current, segmentStyle));
            }
        });
    }
    return labels;
};
function calculateDistanceOrArea(feature) {
    const drawingGeometry = feature.getGeometry();
    if (drawingGeometry instanceof LineString) {
        return calculateLength(drawingGeometry);
    }
    else if (drawingGeometry instanceof Polygon) {
        return calculateArea(drawingGeometry);
    }
    return "";
}
function calculateArea(drawingGeometry) {
    const area = drawingGeometry.getArea();
    let areaText;
    if (area > 10000) {
        areaText = `${Math.round((area / 1000000) * 100) / 100} km2`;
    }
    else {
        areaText = `${Math.round(area * 100) / 100} m2`;
    }
    return areaText;
}
function calculateLength(drawingGeometry) {
    return lengthToString(drawingGeometry.getLength());
}
function getLabelSvg(fillColor, strokeColor) {
    return `<svg width="80" height="75" xmlns="http://www.w3.org/2000/svg">
        <rect opacity="0.9" rx="5" id="svg_1" height="21.25" width="78" y="0" x="1" stroke="${strokeColor}" stroke-width="1" fill="${fillColor}"/>
        <path opacity="0.9" transform="rotate(-180, 40, 27.332)" id="svg_5"
          d="m33.12426,33.08272l6.87567,-11.50139l6.87567,11.50139l-13.75134,0z" fill-opacity="null" stroke-opacity="null"
          stroke-width="1" stroke="${strokeColor}" fill="${fillColor}"/>
       </svg>`;
}
function getSegmentLabel(start, end, segmentStyle) {
    const segment = new LineString([start, end]);
    const style = segmentStyle.clone();
    style.getText().setText(calculateLength(segment));
    style.setGeometry(new Point(segment.getFlatMidpoint()));
    return style;
}
function lengthToString(length = 0) {
    let lengthText;
    if (length > 1000) {
        lengthText = `${Math.round((length / 1000) * 100) / 100} km`;
    }
    else {
        lengthText = `${Math.round(length * 100) / 100} m`;
    }
    return lengthText;
}

var DrawInteractionEventTypes;
(function (DrawInteractionEventTypes) {
    DrawInteractionEventTypes["DRAWEND"] = "drawend";
    DrawInteractionEventTypes["DRAWSTART"] = "drawstart";
})(DrawInteractionEventTypes || (DrawInteractionEventTypes = {}));
var MapComponentDrawTypes;
(function (MapComponentDrawTypes) {
    MapComponentDrawTypes["RECTANGLE"] = "rectangle";
    MapComponentDrawTypes["POLYGON"] = "polygon";
    MapComponentDrawTypes["LINESTRING"] = "linestring";
    MapComponentDrawTypes["POINT"] = "point";
    MapComponentDrawTypes["CIRCLE"] = "circle";
})(MapComponentDrawTypes || (MapComponentDrawTypes = {}));
var DrawingMode;
(function (DrawingMode) {
    DrawingMode["DRAW"] = "drawing";
    DrawingMode["MEASURE"] = "measuring";
})(DrawingMode || (DrawingMode = {}));
class DrawInteractionEvent {
    constructor(type, drawType, mapName, message, event, valid = true) {
        this.type = type;
        this.drawType = drawType;
        this.mapName = mapName;
        this.message = message;
        this.event = event;
        this.valid = valid;
    }
}

var MeasureEventTypes;
(function (MeasureEventTypes) {
    MeasureEventTypes["ENDMEASURE"] = "endmeasure";
})(MeasureEventTypes || (MeasureEventTypes = {}));
class MeasureEvent {
    constructor(type, drawType, mapName, message, measurement, geometry) {
        this.type = type;
        this.drawType = drawType;
        this.mapName = mapName;
        this.message = message;
        this.measurement = measurement;
        this.geometry = geometry;
    }
}

var ModifyInteractionEventTypes;
(function (ModifyInteractionEventTypes) {
    ModifyInteractionEventTypes["MODIFYEND"] = "modifyend";
    ModifyInteractionEventTypes["MOVEEND"] = "moveend";
})(ModifyInteractionEventTypes || (ModifyInteractionEventTypes = {}));
class ModifyInteractionEvent {
    constructor(type, mapName, message, event, valid = true) {
        this.type = type;
        this.mapName = mapName;
        this.message = message;
        this.event = event;
        this.valid = valid;
    }
}

const toGeoJSONFeature = (feature, dataProjection = "EPSG:4326") => {
    const geoJsonFormat = new GeoJSON$1();
    return geoJsonFormat.writeFeatureObject(feature, {
        dataProjection,
        featureProjection: epsg28992,
    });
};
const fromGeoJSONFeature = (feature, dataProjection = "EPSG:4326") => {
    const geoJsonFormat = new GeoJSON$1();
    return geoJsonFormat.readFeature(feature, {
        dataProjection,
        featureProjection: epsg28992,
    });
};
const fromGeoJSONFeatures = (features, dataProjection = "EPSG:4326") => {
    const geoJsonFormat = new GeoJSON$1();
    return geoJsonFormat.readFeatures(features, {
        dataProjection,
        featureProjection: epsg28992,
    });
};
const measureTypeToGeometryType = (measureType) => {
    switch (measureType) {
        case MapComponentDrawTypes.RECTANGLE:
        case MapComponentDrawTypes.POLYGON:
            return "Polygon";
        case MapComponentDrawTypes.CIRCLE:
            return "Circle";
        case MapComponentDrawTypes.LINESTRING:
            return "LineString";
        case MapComponentDrawTypes.POINT:
            return "Point";
    }
};

class DrawValidator {
    constructor(feature, validationFunctions) {
        this.feature = feature;
        this.ignoreNextChange = false;
        this.wasValid = true;
        this.eventsKey = this.feature.on("change", this.onDrawChange.bind(this));
        this.validators = validationFunctions;
    }
    destroy() {
        // Remove any references
        this._styleMap = undefined;
        this.validators = [];
        unByKey(this.eventsKey);
    }
    finish() {
        if (!this.validate(this.feature)) {
            this.feature.setStyle(this._styleMap?.invalidFinishDrawStyle);
            return false;
        }
        return true;
    }
    validate(feature) {
        // Make a copy with slice because the splice method wil alter the original array
        return this.validators
            .slice(0)
            .reduce((_prev, validator, _idx, validators) => {
            if (!validator(feature)) {
                // Stop further validation by emptying the array
                validators.splice(0, validators.length);
                return false;
            }
            return true;
        }, true);
    }
    onDrawChange() {
        if (this.ignoreNextChange) {
            this.ignoreNextChange = false;
            return;
        }
        const isValid = this.validate(this.feature);
        if (isValid !== this.wasValid) {
            // Ignore next change event to prevent event recursion
            this.ignoreNextChange = true;
            if (isValid) {
                this.feature.setStyle(this._styleMap?.drawingDrawStyle);
            }
            else if (this._styleMap?.invalidDrawStyle) {
                this.feature.setStyle(this._styleMap?.invalidDrawStyle);
            }
            this.wasValid = isValid;
        }
    }
    set styleMap(styleMap) {
        this._styleMap = styleMap;
    }
}

class CoreDrawValidationService {
    constructor() {
        this.validators = new Map();
    }
    addValidators(mapIndex, feature, validatorFunctions, styles) {
        if (validatorFunctions.length > 0) {
            const drawValidator = new DrawValidator(feature, validatorFunctions);
            const validators = this.validators.get(mapIndex) || [];
            drawValidator.styleMap = styles;
            validators.push(drawValidator);
            this.validators.set(mapIndex, validators);
        }
    }
    checkAndRemoveValidators(mapIndex) {
        let isValid = true;
        const validators = this.validators.get(mapIndex) || [];
        validators.forEach((drawValidator) => {
            isValid = isValid && drawValidator.finish();
            drawValidator.destroy();
        });
        this.validators.delete(mapIndex);
        return isValid;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: CoreDrawValidationService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: CoreDrawValidationService, providedIn: "root" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: CoreDrawValidationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }] });

class CoreMeasureDrawStyleService {
    getMeasureStyle(measureType, measureOptions, measureStyleMap, modifying = false) {
        const styleLikeMap = {};
        const measureStyles = {
            lengthLabelStyle: lengthStyle,
            segmentLengthLabelStyle: segmentLengthStyle,
            areaLabelStyle: areaStyle,
            drawingDrawStyle: modifying
                ? finishedStyleFunction
                : measuringStyleFunction,
            invalidDrawStyle: modifying
                ? finishedStyleFunction
                : measuringStyleFunction,
            finishDrawStyle: finishedStyleFunction,
            invalidFinishDrawStyle: finishedStyleFunction,
            ...measureStyleMap,
        };
        const drawStyles = [
            "drawingDrawStyle",
            "invalidDrawStyle",
            "finishDrawStyle",
            "invalidFinishDrawStyle",
        ];
        drawStyles.forEach((drawStyle) => {
            styleLikeMap[drawStyle] = this.extendStyleFunctionWithLabels(drawStyle, measureStyles, measureType, measureOptions);
        });
        return styleLikeMap;
    }
    extendStyleFunctionWithLabels(drawStyle, measureStyleMap, measureType, measureOptions) {
        return (feature, resolution) => {
            const geometryType = feature.getGeometry().getType();
            // OpenLayers accepteert een pletoria aan stijlen samengevoegd in StyleLike,
            // dit kan een Style zijn, een array van Styles, of een functie die een Style retourneert
            let style = measureStyleMap[drawStyle] instanceof Style ||
                Array.isArray(measureStyleMap[drawStyle])
                ? measureStyleMap[drawStyle]
                : measureStyleMap[drawStyle].call(this, feature, resolution);
            if (measureType === "Circle") {
                // Circles kunnen geen metingen bevatten
                return style;
            }
            // Voeg labels toe als de geometrietype hetzelfde is en je aan het tekenen bent of het een afgeronde tekening betreft en geen punt is
            if (geometryType === measureType ||
                ((drawStyle === "finishDrawStyle" ||
                    drawStyle === "invalidFinishDrawStyle") &&
                    geometryType !== "Point")) {
                // toon de segment lengte
                if (measureOptions.showSegmentLength) {
                    style = CoreMeasureDrawStyleService.addLabelCallbackToStyle(feature, style, measureStyleMap.segmentLengthLabelStyle, styleSegmentLabelFunction);
                }
                // toon de totale lengte
                if (measureOptions.showTotalLength) {
                    style = CoreMeasureDrawStyleService.addLabelCallbackToStyle(feature, style, measureStyleMap.lengthLabelStyle, styleLengthLabelFunction);
                }
                // vervolgens als je geen lijn of punt tekent, dan toon ook de oppervlakte
                if (geometryType !== "LineString" &&
                    geometryType !== "Point" &&
                    measureOptions.showArea) {
                    style = CoreMeasureDrawStyleService.addLabelCallbackToStyle(feature, style, measureStyleMap.areaLabelStyle, styleAreaLabelFunction);
                }
            }
            return style;
        };
    }
    // voeg aan de stijl de styling van het label en de callbackfunctie toe (voor het berekenen van lengte en oppervlakte)
    static addLabelCallbackToStyle(feature, style, measureStyle, callback) {
        if (Array.isArray(style)) {
            style = style.concat(callback(feature, measureStyle));
        }
        else if (style instanceof Style) {
            style = [style].concat(callback(feature, measureStyle));
        }
        return style;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: CoreMeasureDrawStyleService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: CoreMeasureDrawStyleService, providedIn: "root" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: CoreMeasureDrawStyleService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }] });

class CoreDrawService {
    constructor(coreMapService, coreDrawValidationService, measureDrawStyleService) {
        this.coreMapService = coreMapService;
        this.coreDrawValidationService = coreDrawValidationService;
        this.measureDrawStyleService = measureDrawStyleService;
        this.drawInteractions = new Map();
        this.modifyInteractions = new Map();
        this.moveInteractions = new Map();
        this.snapInteractions = new Map();
        this.drawLayers = new Map();
        this.drawEventsMap = new ObservableMapWrapper(() => new Subject());
        this.measureEventsMap = new ObservableMapWrapper(() => new Subject());
        this.modifyEventsMap = new ObservableMapWrapper(() => new Subject());
        this.drawEndListenerMap = new Map();
        this.drawStyleMap = new Map();
        this.modifyListenersMap = new Map();
        this.moveListenersMap = new Map();
    }
    addFeatureToLayer(layerName, mapIndex, feature) {
        const exists = this.coreMapService.checkMapIndex(mapIndex);
        if (exists) {
            if (feature.getStyle() === undefined || feature.getStyle() === null) {
                this.addStylingToFeature(layerName, mapIndex, feature);
            }
            const layer = this.getDrawLayer(layerName, mapIndex);
            layer.getSource().addFeature(feature);
        }
        return this.coreMapService.decideMapComponentEventType(exists, mapIndex);
    }
    clearLayer(layerName, mapIndex) {
        const exists = this.coreMapService.checkMapIndex(mapIndex);
        if (exists) {
            const layer = this.getDrawLayer(layerName, mapIndex);
            layer.getSource().clear();
        }
        return this.coreMapService.decideMapComponentEventType(exists, mapIndex);
    }
    deleteDrawInteraction(mapIndex) {
        const map = this.coreMapService.getMap(mapIndex);
        if (this.drawInteractions.has(mapIndex)) {
            map.removeInteraction(this.drawInteractions.get(mapIndex));
        }
        this.drawInteractions.delete(mapIndex);
    }
    deleteLayers(mapIndex) {
        this.stopDraw(mapIndex);
        this.stopModify(mapIndex);
        const prefix = `${mapIndex}-`;
        this.stopSnap(mapIndex);
        this.drawLayers.forEach((_layer, key) => {
            if (key.startsWith(prefix)) {
                this.deleteLayer(key.slice(prefix.length), mapIndex);
            }
        });
    }
    deleteLayer(layerName, mapIndex) {
        this.stopDraw(mapIndex);
        this.stopModify(mapIndex);
        this.stopSnap(mapIndex);
        const layer = this.getDrawLayer(layerName, mapIndex);
        layer.setMap(null);
        this.drawLayers.delete(`${mapIndex}-${layerName}`);
    }
    finishCurrentDraw(mapIndex) {
        const drawInteraction = this.drawInteractions.get(mapIndex);
        if (drawInteraction) {
            drawInteraction.finishDrawing();
        }
    }
    getDrawLayer(layerName, mapIndex, style) {
        const key = `${mapIndex}-${layerName}`;
        if (!this.drawLayers.has(key)) {
            const vectorLayer = this.coreMapService.createLayerAndAddToMap(mapIndex, style);
            this.drawLayers.set(key, vectorLayer);
        }
        return this.drawLayers.get(key);
    }
    getDrawObservable(mapIndex) {
        return this.drawEventsMap.getOrCreateObservable(mapIndex);
    }
    getModifyEventsObservable(mapIndex) {
        return this.modifyEventsMap.getOrCreateObservable(mapIndex);
    }
    getMeasureEventsObservable(mapIndex) {
        return this.measureEventsMap.getOrCreateObservable(mapIndex);
    }
    setDrawStyle(layerName, mapIndex, drawStyle) {
        this.drawStyleMap.set(`${mapIndex}-${layerName}`, drawStyle);
    }
    setLayerZIndex(layerName, mapIndex, index) {
        const layer = this.getDrawLayer(layerName, mapIndex);
        layer.setZIndex(index);
        layer.changed();
    }
    startDraw(layerName, mapIndex, drawType, drawOptions = {}) {
        this.stopDraw(mapIndex);
        this.stopMove(mapIndex);
        this.setLayerVisibility(layerName, mapIndex, true);
        this.drawEventsMap.getOrCreateObservable(mapIndex);
        const geometryType = measureTypeToGeometryType(drawType);
        const selectedStyle = this.decideAndGetStyles(layerName, mapIndex, geometryType, drawOptions);
        const drawInteraction = this.getDrawInteraction(layerName, mapIndex, drawType, selectedStyle, drawOptions);
        drawInteraction.on("drawstart", (event) => {
            this.drawEventsMap
                .getOrCreateSubject(mapIndex)
                .next(new DrawInteractionEvent(DrawInteractionEventTypes.DRAWSTART, drawType, mapIndex, `DrawStart on ${layerName}`, event));
            if (drawOptions.validators) {
                this.coreDrawValidationService.addValidators(mapIndex, event.feature, drawOptions.validators, selectedStyle);
            }
        });
        const id = drawInteraction.on("drawend", (event) => {
            if (selectedStyle) {
                event.feature.setStyle(selectedStyle.finishDrawStyle);
            }
            const valid = this.coreDrawValidationService.checkAndRemoveValidators(mapIndex);
            const areaOrDistance = calculateDistanceOrArea(event.feature);
            const geometry = event.feature.getGeometry();
            event.feature.setProperties({
                areaOrDistance,
                measurement: this.getDrawType(drawOptions),
            });
            this.drawEventsMap
                .getOrCreateSubject(mapIndex)
                .next(new DrawInteractionEvent(DrawInteractionEventTypes.DRAWEND, drawType, mapIndex, `DrawEnd on ${layerName}`, event, valid));
            if (CoreDrawService.wasMeasuring(drawOptions)) {
                this.measureEventsMap
                    .getOrCreateSubject(mapIndex)
                    .next(new MeasureEvent(MeasureEventTypes.ENDMEASURE, drawType, mapIndex, `MeasureEnd on ${layerName}`, areaOrDistance, geometry));
            }
        });
        this.drawEndListenerMap.set(mapIndex, id);
        this.startSnapAgainIfExists(layerName, mapIndex);
    }
    // Segments are not supported yet and polygon has only area.
    getDrawType(options) {
        if (options.showArea !== undefined && options.showArea) {
            return "area";
        }
        else if (options.showTotalLength !== undefined &&
            options.showTotalLength) {
            return "length";
        }
        else {
            return "none";
        }
    }
    startModify(layerName, mapIndex, drawOptions, deleteCondition = never, insertVertexCondition = never) {
        this.stopModify(mapIndex);
        this.stopMove(mapIndex);
        this.setLayerVisibility(layerName, mapIndex, true);
        const source = this.getDrawLayer(layerName, mapIndex).getSource();
        const modify = new Modify({
            source,
            deleteCondition: deleteCondition,
            insertVertexCondition: insertVertexCondition,
        });
        const map = this.coreMapService.getMap(mapIndex);
        map.addInteraction(modify);
        this.modifyInteractions.set(mapIndex, modify);
        const modifyEventSubject = this.modifyEventsMap.getOrCreateSubject(mapIndex);
        const eventsKeys = [];
        const validators = drawOptions?.validators || [];
        if (validators.length > 0) {
            eventsKeys.push(modify.on("modifystart", (event) => {
                event.features.forEach((feature) => {
                    const selectedStyle = this.decideAndGetStyles(layerName, mapIndex, feature.getGeometry().getType(), drawOptions, true);
                    this.coreDrawValidationService.addValidators(mapIndex, feature, validators, selectedStyle);
                });
            }));
        }
        eventsKeys.push(modify.on("modifyend", (event) => {
            if (event.features) {
                event.features.forEach((feature) => {
                    const areaOrDistance = calculateDistanceOrArea(feature);
                    feature.set("areaOrDistance", areaOrDistance);
                });
            }
            modifyEventSubject.next(new ModifyInteractionEvent(ModifyInteractionEventTypes.MODIFYEND, mapIndex, `bewerken ${layerName}`, event, this.coreDrawValidationService.checkAndRemoveValidators(mapIndex)));
        }));
        this.modifyListenersMap.set(mapIndex, eventsKeys);
        this.startSnapAgainIfExists(layerName, mapIndex);
    }
    startMove(layerName, mapIndex, drawOptions = {}) {
        const map = this.coreMapService.getMap(mapIndex);
        const drawLayer = this.getDrawLayer(layerName, mapIndex);
        // source.
        this.stopModify(mapIndex);
        this.stopDraw(mapIndex);
        this.stopMove(mapIndex);
        const features = new Collection();
        const move = new Translate({ features });
        const modifyEventSubject = this.modifyEventsMap.getOrCreateSubject(mapIndex);
        let selected;
        let isTranslating = false;
        this.moveInteractions.set(mapIndex, move);
        map.addInteraction(move);
        const eventsKeys = [];
        eventsKeys.push(move.on("translatestart", () => {
            isTranslating = true;
            map.getViewport().style.cursor = "grabbing";
            if (drawOptions.validators) {
                const selectedStyle = this.decideAndGetStyles(layerName, mapIndex, selected.getGeometry().getType(), drawOptions);
                this.coreDrawValidationService.addValidators(mapIndex, selected, drawOptions.validators, selectedStyle);
            }
        }), move.on("translateend", (event) => {
            isTranslating = false;
            map.getViewport().style.cursor = "grab";
            modifyEventSubject.next(new ModifyInteractionEvent(ModifyInteractionEventTypes.MOVEEND, mapIndex, `verplaatsen feature op ${layerName}`, event, this.coreDrawValidationService.checkAndRemoveValidators(mapIndex)));
        }), map.on("pointermove", (evt) => {
            if (isTranslating) {
                return;
            }
            let onFeature = false;
            map.forEachFeatureAtPixel(evt.pixel, (feat) => {
                onFeature = true;
                selected = feat;
                map.getViewport().style.cursor = "grab";
                return true;
            }, { layerFilter: (layer) => layer === drawLayer });
            features.clear();
            if (onFeature) {
                if (selected) {
                    features.push(selected);
                }
            }
            else {
                selected = undefined;
                map.getViewport().style.cursor = "";
            }
        }));
        this.moveListenersMap.set(mapIndex, eventsKeys);
    }
    startSnap(layerName, mapIndex) {
        // stop previous snap interaction
        this.stopSnap(mapIndex);
        const source = this.getDrawLayer(layerName, mapIndex).getSource();
        const snap = new Snap({
            source,
        });
        this.snapInteractions.set(`${mapIndex}-${layerName}`, snap);
        this.coreMapService.getMap(mapIndex).addInteraction(snap);
    }
    stopDraw(mapIndex) {
        const interaction = this.drawInteractions.get(mapIndex);
        if (interaction) {
            unByKey(this.drawEndListenerMap.get(mapIndex));
            this.drawEndListenerMap.delete(mapIndex);
            this.deleteDrawInteraction(mapIndex);
        }
    }
    stopModify(mapIndex) {
        const interaction = this.modifyInteractions.get(mapIndex);
        if (interaction) {
            unByKey(this.modifyListenersMap.get(mapIndex));
            this.modifyListenersMap.delete(mapIndex);
            this.modifyInteractions.delete(mapIndex);
            this.coreMapService.getMap(mapIndex).removeInteraction(interaction);
        }
    }
    stopMove(mapIndex) {
        const interaction = this.moveInteractions.get(mapIndex);
        if (interaction) {
            unByKey(this.moveListenersMap.get(mapIndex));
            this.moveListenersMap.delete(mapIndex);
            this.moveInteractions.delete(mapIndex);
            this.coreMapService.getMap(mapIndex).removeInteraction(interaction);
        }
    }
    stopSnap(mapIndex) {
        const prefix = `${mapIndex}-`;
        this.snapInteractions.forEach((interaction, key) => {
            if (key.startsWith(prefix)) {
                this.coreMapService.getMap(mapIndex).removeInteraction(interaction);
                this.snapInteractions.delete(key);
            }
        });
    }
    setLayerVisibility(layerName, mapIndex, visible) {
        const layer = this.getDrawLayer(layerName, mapIndex);
        layer.setVisible(visible);
        layer.changed();
    }
    toggleLayer(layerName, mapIndex) {
        const layer = this.getDrawLayer(layerName, mapIndex);
        layer.setVisible(!layer.getVisible());
        layer.changed();
    }
    decideAndGetStyles(layerName, mapIndex, measureType, measureOptions, modifying = false) {
        return this.measureDrawStyleService.getMeasureStyle(measureType, measureOptions, this.drawStyleMap.get(`${mapIndex}-${layerName}`), modifying);
    }
    getDrawInteraction(layerName, mapIndex, drawType, styleLikeMap, options) {
        if (!this.drawInteractions.has(mapIndex)) {
            let drawInteraction;
            let geometryFunction;
            let geometryType;
            switch (drawType) {
                case MapComponentDrawTypes.RECTANGLE:
                    // type Circle and geometryFunction createBox() enables drawing rectangles (default Openlayers)
                    geometryFunction = createBox;
                    geometryType = "Circle";
                    break;
                case MapComponentDrawTypes.POLYGON:
                    geometryType = "Polygon";
                    break;
                case MapComponentDrawTypes.LINESTRING:
                    geometryType = "LineString";
                    break;
                case MapComponentDrawTypes.POINT:
                    geometryType = "Point";
                    break;
                case MapComponentDrawTypes.CIRCLE:
                    geometryType = "Circle";
                    break;
                default:
                    throw new Error("Unknown draw type");
            }
            if (geometryType) {
                drawInteraction = this.createDrawObject(layerName, mapIndex, geometryType, styleLikeMap, options, geometryFunction ? geometryFunction() : undefined);
                const map = this.coreMapService.getMap(mapIndex);
                map.addInteraction(drawInteraction);
                this.drawInteractions.set(mapIndex, drawInteraction);
            }
        }
        return this.drawInteractions.get(mapIndex);
    }
    createDrawObject(layerName, mapIndex, type, styleLikeMap, options, geoFunction) {
        const layer = this.getDrawLayer(layerName, mapIndex, styleLikeMap?.finishDrawStyle);
        const source = layer.getSource();
        const drawOptions = {
            ...options,
            source,
            type,
            stopClick: true,
            geometryFunction: geoFunction,
        };
        if (styleLikeMap) {
            drawOptions.style = styleLikeMap.drawingDrawStyle;
        }
        return new Draw(drawOptions);
    }
    startSnapAgainIfExists(layerName, mapIndex) {
        // if SnapInteraction exists for mapIndex, add SnapInteraction again, so it added as last interaction to the map.
        // SnapInteraction must be added after Modify- or DrawInteraction
        const interaction = this.snapInteractions.get(`${mapIndex}-${layerName}`);
        if (interaction) {
            this.startSnap(layerName, mapIndex);
        }
    }
    static wasMeasuring(measureOptions) {
        return (!!measureOptions.showSegmentLength ||
            !!measureOptions.showTotalLength ||
            !!measureOptions.showArea);
    }
    addStylingToFeature(layerName, mapIndex, feature) {
        const styleLikeMap = this.drawStyleMap.get(`${mapIndex}-${layerName}`);
        if (styleLikeMap) {
            feature.setStyle(styleLikeMap.finishDrawStyle);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: CoreDrawService, deps: [{ token: CoreMapService }, { token: CoreDrawValidationService }, { token: CoreMeasureDrawStyleService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: CoreDrawService, providedIn: "root" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: CoreDrawService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: function () { return [{ type: CoreMapService }, { type: CoreDrawValidationService }, { type: CoreMeasureDrawStyleService }]; } });

class MapComponent {
    set minZoomlevel(value) {
        this._minZoomlevel = Math.max(0, Math.min(CrsConfigService.MAX_ZOOMLEVEL, value));
    }
    get minZoomlevel() {
        return this._minZoomlevel;
    }
    set maxZoomlevel(value) {
        this._maxZoomlevel = Math.max(1, Math.min(CrsConfigService.MAX_ZOOMLEVEL, value));
    }
    get maxZoomlevel() {
        return this._maxZoomlevel;
    }
    constructor(coreMapService, mapEventsService, coreLoadingService, coreSelectionService, coreDrawService) {
        this.coreMapService = coreMapService;
        this.mapEventsService = mapEventsService;
        this.coreLoadingService = coreLoadingService;
        this.coreSelectionService = coreSelectionService;
        this.coreDrawService = coreDrawService;
        this.mapName = DEFAULT_MAP;
        this.mapTabIndex = undefined;
        this.events = new EventEmitter();
        this.eventsMap = [];
        this._minZoomlevel = 0;
        this._maxZoomlevel = 14;
        // ol event type name
        this.OL_MOVEEND = "moveend";
        this.OL_SINGLECLICK = "singleclick";
        this.OL_CHANGE_RESOLUTION = "change:resolution";
        this.OL_PRECOMPOSE = "precompose";
        this.OL_RENDERCOMPLETE = "rendercomplete";
    }
    ngAfterViewInit() {
        if (this._minZoomlevel > this._maxZoomlevel) {
            this.events.emit(new MapComponentEvent(MapComponentEventTypes.UNSUCCESSFUL, this.mapName, `Kaart kon niet worden geladen omdat de waarde van minZoomLevel (${this._minZoomlevel}) ` +
                `hoger is dan die van maxZoomLevel (${this._maxZoomlevel}).`));
        }
        else {
            const map = this.coreMapService.createAndGetMap(this.mapName, this._minZoomlevel, this._maxZoomlevel);
            map.setTarget(this.mapElement.nativeElement.id);
            this.eventsMap.push(map.on(this.OL_PRECOMPOSE, this.processEvent.bind(this)));
            this.eventsMap.push(map.on(this.OL_RENDERCOMPLETE, this.processEvent.bind(this)));
            // map events
            // binding listener function'in 'map.on' to 'this' using bind()
            this.eventsMap.push(map.on(this.OL_SINGLECLICK, this.processEvent.bind(this)));
            this.eventsMap.push(map.on(this.OL_MOVEEND, this.processEvent.bind(this)));
            // event on the view of this map.
            const view = map.getView();
            this.eventsMap.push(view.on(this.OL_CHANGE_RESOLUTION, this.processEvent.bind(this)));
            view.setZoom(3);
            this.initializeLoader();
            this.events.emit(new MapComponentEvent(MapComponentEventTypes.MAPINITIALIZED, this.mapName, "Het ggc-map component is geinitialiseerd."));
        }
    }
    processEvent(mapEvent) {
        switch (mapEvent.type) {
            case this.OL_CHANGE_RESOLUTION:
                this.lastChangeResolutionEvent = mapEvent;
                break;
            case this.OL_MOVEEND:
                const mapViewState = this.getLocationFromMapEvent(mapEvent);
                this.events.emit(new MapComponentEvent(MapComponentEventTypes.ZOOMENDLOCATION, this.mapName, "Het zoomen is beeindigd, dit event bevat X en Y en zoomlevel.", undefined, mapViewState));
                if (this.lastChangeResolutionEvent) {
                    this.events.emit(new MapComponentEvent(MapComponentEventTypes.ZOOMEND, this.mapName, "Het zoomen is beeindigd, dit is het laatste ol.MapEvent.", undefined, mapEvent));
                    this.lastChangeResolutionEvent = undefined;
                    this.mapEventsService.emitZoomendEventForMap(mapEvent, this.mapName);
                }
                break;
            case this.OL_SINGLECLICK:
                // order of events is important, because the singleclick event should be emitted before
                // getFeatureInfo events on the ggc-layer componenten are emitted!
                // First emit MapComponent singleclick event and send singleclick event to the CoreSelectionService
                // then, send singleclick event on MapEventsService, because the ggc-layer componenten are subscribed to the mapEventsService
                this.events.emit(new MapComponentEvent(MapComponentEventTypes.SINGLECLICK, this.mapName, "Er is een singleClick gegenereerd.", undefined, mapEvent));
                this.coreSelectionService.handleSingleclickEventForMap(mapEvent.coordinate, this.mapName);
                this.mapEventsService.emitSingleclickEventForMap(mapEvent, this.mapName);
                break;
        }
    }
    getLocationFromMapEvent(mapEvent) {
        const zoom = mapEvent.map.getView().getZoom();
        const coordinate = mapEvent.map.getView().getCenter();
        return new MapViewState(coordinate, zoom);
    }
    ngOnDestroy() {
        // Unsubscribe from Observable by key
        while (this.eventsMap.length > 0) {
            unByKey(this.eventsMap.pop());
        }
        if (this.isLoading$) {
            this.isLoading$.unsubscribe();
        }
        /* destroying the olMap, optional drawInteraction and selectionService. Destroying the OlMap itself last to prevent issues during
        destruction of the other parts */
        this.coreLoadingService.destroyLoadersForMap(this.mapName);
        if (this.coreDrawService) {
            this.coreDrawService.deleteLayers(this.mapName);
        }
        this.coreSelectionService.destroySelectionForMap(this.mapName);
        // destroying the events
        this.mapEventsService.destroyEventsForMap(this.mapName);
        // destroying the map
        this.coreMapService.destroyMap(this.mapName);
    }
    initializeLoader() {
        this.isLoading$ = this.coreLoadingService
            .isLoading(this.mapName)
            .subscribe((value) => {
            const message = value
                ? `De kaart is aan het laden`
                : `De kaart is klaar met laden`;
            this.events.emit(new MapComponentEvent(MapComponentEventTypes.LOADING, this.mapName, message, undefined, value));
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: MapComponent, deps: [{ token: CoreMapService }, { token: CoreMapEventsService }, { token: CoreLoadingService }, { token: CoreSelectionService }, { token: CoreDrawService, optional: true }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.3", type: MapComponent, selector: "ggc-map", inputs: { mapName: "mapName", mapTabIndex: "mapTabIndex", minZoomlevel: "minZoomlevel", maxZoomlevel: "maxZoomlevel" }, outputs: { events: "events" }, viewQueries: [{ propertyName: "mapElement", first: true, predicate: ["mapElement"], descendants: true, static: true }], ngImport: i0, template: "<div\n  #mapElement\n  [id]=\"mapName\"\n  class=\"ggc-ol-map\"\n  [attr.tabindex]=\"mapTabIndex\"\n></div>\n", styles: [".ggc-ol-map{height:100%;width:100%}::ng-deep .ol-attribution li{font-size:1.1rem;line-height:1.375rem}::ng-deep .ol-viewport canvas{touch-action:none}::ng-deep .ol-hidden{display:none}::ng-deep .map-control:not(.ol-hidden){align-items:center;justify-content:center;background:transparent;display:flex;flex-direction:column;order:1;padding:2px 0;position:relative;width:4rem}::ng-deep .map-control:not(.ol-hidden):has(.map-control-reset){order:0}::ng-deep .map-control:not(.ol-hidden) button[aria-expanded=false]+ul{display:none}::ng-deep .map-control:not(.ol-hidden) button[aria-expanded=true]+ul{align-items:flex-start;background:white;border:1px solid #bfcddf;border-radius:4px;display:flex;flex-direction:column;justify-content:center;min-height:3rem;position:absolute;padding:.5em 1em;right:5rem;top:0}::ng-deep .map-control:not(.ol-hidden) button[aria-expanded=true]+ul li{list-style-type:none;white-space:nowrap}::ng-deep .map-control:not(.ol-hidden) button[aria-expanded=true]+ul li:before{content:none}::ng-deep .ol-overlaycontainer-stopevent{align-items:flex-end;justify-content:flex-end;display:flex;flex-direction:column;padding-right:1.5em;padding-bottom:1.5em}::ng-deep .ol-overlaycontainer-stopevent .ol-overlay-container{top:0;left:0}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: MapComponent, decorators: [{
            type: Component,
            args: [{ selector: "ggc-map", template: "<div\n  #mapElement\n  [id]=\"mapName\"\n  class=\"ggc-ol-map\"\n  [attr.tabindex]=\"mapTabIndex\"\n></div>\n", styles: [".ggc-ol-map{height:100%;width:100%}::ng-deep .ol-attribution li{font-size:1.1rem;line-height:1.375rem}::ng-deep .ol-viewport canvas{touch-action:none}::ng-deep .ol-hidden{display:none}::ng-deep .map-control:not(.ol-hidden){align-items:center;justify-content:center;background:transparent;display:flex;flex-direction:column;order:1;padding:2px 0;position:relative;width:4rem}::ng-deep .map-control:not(.ol-hidden):has(.map-control-reset){order:0}::ng-deep .map-control:not(.ol-hidden) button[aria-expanded=false]+ul{display:none}::ng-deep .map-control:not(.ol-hidden) button[aria-expanded=true]+ul{align-items:flex-start;background:white;border:1px solid #bfcddf;border-radius:4px;display:flex;flex-direction:column;justify-content:center;min-height:3rem;position:absolute;padding:.5em 1em;right:5rem;top:0}::ng-deep .map-control:not(.ol-hidden) button[aria-expanded=true]+ul li{list-style-type:none;white-space:nowrap}::ng-deep .map-control:not(.ol-hidden) button[aria-expanded=true]+ul li:before{content:none}::ng-deep .ol-overlaycontainer-stopevent{align-items:flex-end;justify-content:flex-end;display:flex;flex-direction:column;padding-right:1.5em;padding-bottom:1.5em}::ng-deep .ol-overlaycontainer-stopevent .ol-overlay-container{top:0;left:0}\n"] }]
        }], ctorParameters: function () { return [{ type: CoreMapService }, { type: CoreMapEventsService }, { type: CoreLoadingService }, { type: CoreSelectionService }, { type: CoreDrawService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { mapName: [{
                type: Input
            }], mapTabIndex: [{
                type: Input
            }], events: [{
                type: Output
            }], mapElement: [{
                type: ViewChild,
                args: ["mapElement", { static: true }]
            }], minZoomlevel: [{
                type: Input
            }], maxZoomlevel: [{
                type: Input
            }] } });

class MapModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: MapModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.3", ngImport: i0, type: MapModule, declarations: [MapComponent], exports: [MapComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: MapModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: MapModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [MapComponent],
                    exports: [MapComponent],
                }]
        }] });

class CoordinateFormatPipe {
    transform(coord, decimals = 2, format = "RD: x = {x} m; y = {y} m") {
        if (!coord) {
            return "";
        }
        const numberFmt = new Intl.NumberFormat("nl-NL", {
            maximumFractionDigits: decimals,
            minimumFractionDigits: decimals,
            useGrouping: false,
        });
        const [x, y] = [numberFmt.format(coord[0]), numberFmt.format(coord[1])];
        return format.replace("{x}", x).replace("{y}", y);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: CoordinateFormatPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.3", ngImport: i0, type: CoordinateFormatPipe, name: "coordinateFormat" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: CoordinateFormatPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: "coordinateFormat",
                }]
        }] });

class MousePositionComponent {
    get format() {
        return this._format;
    }
    set format(value) {
        this.mode = typeof value === "string" ? "string" : "callback";
        this._format = value;
    }
    constructor(coreMapService, crsConfigService, mapDetailsContainer) {
        this.coreMapService = coreMapService;
        this.crsConfigService = crsConfigService;
        this.mapDetailsContainer = mapDetailsContainer;
        this.decimalDigits = 2;
        this.mapName = DEFAULT_MAP;
        this.placeholder = " ";
        this.projection = epsg28992;
        this._format = "RD: x = {x} m; y = {y} m";
        this.mode = "string";
    }
    ngOnInit() {
        this.mousePositionControl = new MousePosition(this.createMousePositionOptions());
        this.setCoordinateFormatOnMousePositionControl();
        this.setMousePositionControlOnMap();
    }
    ngOnDestroy() {
        if (this.map !== undefined) {
            this.map.removeControl(this.mousePositionControl);
        }
    }
    createMousePositionOptions() {
        const options = {
            projection: this.crsConfigService.getRdNewCrsConfig().projectionCode,
            placeholder: this.placeholder,
        };
        // when parent component MapDetailsContainerComponent is present, target for mouseposition is set to nativeElement
        // to show the mouse position within the parent component instead of the default location on the map
        if (this.mapDetailsContainer) {
            options.target = this.ggcMousePosition.nativeElement;
        }
        return options;
    }
    setCoordinateFormatOnMousePositionControl() {
        // 'bind' wordt hier gebruikt om de context van het component mee te geven
        // zodat de methode wordt uitgevoerd binnen de context van deze class in plaats van binnen OpenLayers.
        this.mousePositionControl.setCoordinateFormat(this.createCoordinateFormat.bind(this));
    }
    createCoordinateFormat(coord) {
        if (!coord) {
            return "";
        }
        if (this.projection !== epsg28992) {
            if (!get(this.projection)) {
                throw new Error(`Unknown projection '${this.projection}'`);
            }
            else {
                coord = transform(coord, epsg28992, this.projection);
            }
        }
        if (this.mode === "string") {
            return new CoordinateFormatPipe().transform(coord, this.decimalDigits, this._format);
        }
        else {
            return this._format(coord);
        }
    }
    setMousePositionControlOnMap() {
        this.map = this.coreMapService.getMap(this.mapName);
        this.map.addControl(this.mousePositionControl);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: MousePositionComponent, deps: [{ token: CoreMapService }, { token: CrsConfigService }, { token: MapDetailsContainerComponent, optional: true }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.3", type: MousePositionComponent, isStandalone: true, selector: "ggc-mouse-position", inputs: { decimalDigits: "decimalDigits", mapName: "mapName", placeholder: "placeholder", projection: "projection", format: "format" }, viewQueries: [{ propertyName: "ggcMousePosition", first: true, predicate: ["ggcMousePosition"], descendants: true, static: true }], ngImport: i0, template: "<div #ggcMousePosition class=\"ggc-mouse-position\"></div>\n", styles: ["::ng-deep .ggc-mouse-position .ol-mouse-position{position:unset;top:unset;right:unset}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: MousePositionComponent, decorators: [{
            type: Component,
            args: [{ selector: "ggc-mouse-position", standalone: true, template: "<div #ggcMousePosition class=\"ggc-mouse-position\"></div>\n", styles: ["::ng-deep .ggc-mouse-position .ol-mouse-position{position:unset;top:unset;right:unset}\n"] }]
        }], ctorParameters: function () { return [{ type: CoreMapService }, { type: CrsConfigService }, { type: MapDetailsContainerComponent, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { decimalDigits: [{
                type: Input
            }], mapName: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], projection: [{
                type: Input
            }], ggcMousePosition: [{
                type: ViewChild,
                args: ["ggcMousePosition", { static: true }]
            }], format: [{
                type: Input
            }] } });

class MousePositionModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: MousePositionModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.3", ngImport: i0, type: MousePositionModule, imports: [MousePositionComponent], exports: [MousePositionComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: MousePositionModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: MousePositionModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [MousePositionComponent],
                    exports: [MousePositionComponent],
                }]
        }] });

class ScaleDenominatorComponent {
    constructor(coreMapService, mapEventsService) {
        this.coreMapService = coreMapService;
        this.mapEventsService = mapEventsService;
        this.mapName = DEFAULT_MAP;
        this.INCHES_PER_METER = 39.37;
        this.POINTS_PER_INCH = 90.71446714322;
    }
    ngOnInit() {
        this.map = this.coreMapService.getMap(this.mapName);
        const zoomendObservable = this.mapEventsService.getZoomendObservableForMap(this.mapName);
        this.zoomendSubscription = zoomendObservable.subscribe(() => {
            this.calculateScaleDenominator();
        });
    }
    calculateScaleDenominator() {
        // aantal ppi berekend op basis van aanname van 0.28 mm per pixel uit de Nederlandse richtlijn tiling, bijlage B:
        // https://www.geonovum.nl/uploads/standards/downloads/nederlandse_richtlijn_tiling_-_versie_1.1.pdf
        // ppi = aantal mm per inch (= 25.4mm) / mm per pixel (0.28mm) = 90.7142857142857
        // Deze berekende ppi blijkt net niet nauwkeurig genoeg, bij de hoge resoluties wijkt het schaalgetal een klein beetje af
        // van de verwachte waarde. Daarom ppi berekend aan de hand van de zoomniveaus uit het document, bijv. zoomniveau 3:
        // 1536000 = 430.080 *  39.37 * ? >>> ? = 90.71446714322
        const resolution = this.map.getView().getResolution();
        // schaalgetal = resolutie (m/pixel) * inches/m * pixels/inch
        if (resolution) {
            this.currentScaleDenominator = Math.round(resolution * this.INCHES_PER_METER * this.POINTS_PER_INCH);
        }
        else {
            this.currentScaleDenominator = undefined;
        }
    }
    ngOnDestroy() {
        if (this.zoomendSubscription) {
            this.zoomendSubscription.unsubscribe();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: ScaleDenominatorComponent, deps: [{ token: CoreMapService }, { token: CoreMapEventsService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.3", type: ScaleDenominatorComponent, selector: "ggc-scale-denominator", inputs: { mapName: "mapName" }, ngImport: i0, template: "<div *ngIf=\"currentScaleDenominator\" class=\"ggc-scale-denominator\">\n  1:{{ currentScaleDenominator }}\n</div>\n", dependencies: [{ kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: ScaleDenominatorComponent, decorators: [{
            type: Component,
            args: [{ selector: "ggc-scale-denominator", template: "<div *ngIf=\"currentScaleDenominator\" class=\"ggc-scale-denominator\">\n  1:{{ currentScaleDenominator }}\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: CoreMapService }, { type: CoreMapEventsService }]; }, propDecorators: { mapName: [{
                type: Input
            }] } });

class ScaleDenominatorModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: ScaleDenominatorModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.3", ngImport: i0, type: ScaleDenominatorModule, declarations: [ScaleDenominatorComponent], imports: [CommonModule], exports: [ScaleDenominatorComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: ScaleDenominatorModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: ScaleDenominatorModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [ScaleDenominatorComponent],
                    imports: [CommonModule],
                    exports: [ScaleDenominatorComponent],
                }]
        }] });

class ScaleLineComponent {
    constructor(coreMapService, mapDetailsContainer) {
        this.coreMapService = coreMapService;
        this.mapDetailsContainer = mapDetailsContainer;
        this.mapName = DEFAULT_MAP;
        this.units = "metric";
    }
    ngOnInit() {
        this.scaleControl = new ScaleLine(this.createScaleLineOptions());
        this.map = this.coreMapService.getMap(this.mapName);
        this.map.addControl(this.scaleControl);
    }
    createScaleLineOptions() {
        const options = {
            units: this.units,
        };
        // when parent component MapDetailsContainerComponent is present, target for scale line is set to nativeElement
        // to show the mouse position within the parent component instead of the default location on the map
        if (this.mapDetailsContainer) {
            options.target = this.ggcScaleLine.nativeElement;
        }
        return options;
    }
    ngOnDestroy() {
        if (this.map !== undefined) {
            this.map.removeControl(this.scaleControl);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: ScaleLineComponent, deps: [{ token: CoreMapService }, { token: MapDetailsContainerComponent, optional: true }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.3", type: ScaleLineComponent, selector: "ggc-scale-line", inputs: { mapName: "mapName", units: "units" }, viewQueries: [{ propertyName: "ggcScaleLine", first: true, predicate: ["ggcScaleLine"], descendants: true, static: true }], ngImport: i0, template: "<div #ggcScaleLine class=\"ggc-scale-line\"></div>\n", styles: ["::ng-deep .ggc-scale-line .ol-scale-line{bottom:unset;position:unset}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: ScaleLineComponent, decorators: [{
            type: Component,
            args: [{ selector: "ggc-scale-line", template: "<div #ggcScaleLine class=\"ggc-scale-line\"></div>\n", styles: ["::ng-deep .ggc-scale-line .ol-scale-line{bottom:unset;position:unset}\n"] }]
        }], ctorParameters: function () { return [{ type: CoreMapService }, { type: MapDetailsContainerComponent, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { mapName: [{
                type: Input
            }], units: [{
                type: Input
            }], ggcScaleLine: [{
                type: ViewChild,
                args: ["ggcScaleLine", { static: true }]
            }] } });

class ScaleLineModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: ScaleLineModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.3", ngImport: i0, type: ScaleLineModule, declarations: [ScaleLineComponent], exports: [ScaleLineComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: ScaleLineModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: ScaleLineModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [ScaleLineComponent],
                    exports: [ScaleLineComponent],
                }]
        }] });

class SelectionModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: SelectionModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.3", ngImport: i0, type: SelectionModule, imports: [CommonModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: SelectionModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: SelectionModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [],
                }]
        }] });

class ToolbarItemComponent {
    constructor() {
        this.activeChanged = new EventEmitter();
        this.id = Math.random().toString(36).substring(2);
        this._active = false;
    }
    onClick() {
        if (this.clickCallback) {
            this.clickCallback();
        }
        else {
            this.handleClick();
        }
    }
    handleClick() {
        this._active = !this._active;
        this.activeChanged.emit({
            toolbarItemComponent: this,
            active: this._active,
        });
    }
    set active(state) {
        this._active = state;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: ToolbarItemComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.3", type: ToolbarItemComponent, selector: "ggc-toolbar-item", inputs: { icon: "icon", title: "title", clickCallback: "clickCallback" }, outputs: { activeChanged: "activeChanged" }, viewQueries: [{ propertyName: "toolbarItemTemplate", first: true, predicate: ["toolbarItemTemplate"], descendants: true }, { propertyName: "toolbarItem", first: true, predicate: ["toolbarItem"], descendants: true }], ngImport: i0, template: "<div\n  #toolbarItem\n  class=\"ggc-toolbar-item\"\n  role=\"presentation\"\n  [ngClass]=\"{ active: _active }\"\n>\n  <button\n    class=\"btn btn-tools-sm\"\n    (click)=\"onClick()\"\n    [id]=\"id + '-btn'\"\n    [title]=\"title\"\n  >\n    <span class=\"btn-tools-sm-icon\" aria-hidden=\"true\" [ngClass]=\"icon\"></span>\n    <span class=\"sr-only\">{{ title }}</span>\n  </button>\n</div>\n<ng-template #toolbarItemTemplate class=\"ggc-toolbar-item-content\">\n  <div class=\"card-body card-body-tools ggc-toolbar-content\">\n    <div class=\"tab-content\">\n      <div\n        [ngClass]=\"{ active: _active, 'd-sm-none': !_active }\"\n        [id]=\"id\"\n        class=\"tab-pane\"\n        role=\"tabpanel\"\n        [attr.aria-labelledby]=\"id + '-btn'\"\n      >\n        <ng-content></ng-content>\n      </div>\n    </div>\n  </div>\n</ng-template>\n", dependencies: [{ kind: "directive", type: i2$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: ToolbarItemComponent, decorators: [{
            type: Component,
            args: [{ selector: "ggc-toolbar-item", template: "<div\n  #toolbarItem\n  class=\"ggc-toolbar-item\"\n  role=\"presentation\"\n  [ngClass]=\"{ active: _active }\"\n>\n  <button\n    class=\"btn btn-tools-sm\"\n    (click)=\"onClick()\"\n    [id]=\"id + '-btn'\"\n    [title]=\"title\"\n  >\n    <span class=\"btn-tools-sm-icon\" aria-hidden=\"true\" [ngClass]=\"icon\"></span>\n    <span class=\"sr-only\">{{ title }}</span>\n  </button>\n</div>\n<ng-template #toolbarItemTemplate class=\"ggc-toolbar-item-content\">\n  <div class=\"card-body card-body-tools ggc-toolbar-content\">\n    <div class=\"tab-content\">\n      <div\n        [ngClass]=\"{ active: _active, 'd-sm-none': !_active }\"\n        [id]=\"id\"\n        class=\"tab-pane\"\n        role=\"tabpanel\"\n        [attr.aria-labelledby]=\"id + '-btn'\"\n      >\n        <ng-content></ng-content>\n      </div>\n    </div>\n  </div>\n</ng-template>\n" }]
        }], propDecorators: { icon: [{
                type: Input
            }], title: [{
                type: Input
            }], clickCallback: [{
                type: Input
            }], toolbarItemTemplate: [{
                type: ViewChild,
                args: ["toolbarItemTemplate"]
            }], toolbarItem: [{
                type: ViewChild,
                args: ["toolbarItem"]
            }], activeChanged: [{
                type: Output
            }] } });

class MapService {
    constructor(coreMapService, extraLayers = [[]]) {
        this.coreMapService = coreMapService;
        if (extraLayers) {
            this.coreMapService.setExtraLayers(extraLayers.flat());
        }
        this.format = new WKT();
    }
    getMap(mapIndex) {
        return this.coreMapService.getMap(mapIndex);
    }
    getLayer(layerId, mapIndex = DEFAULT_MAP) {
        return this.coreMapService.getLayer(layerId, mapIndex);
    }
    getExtraLayer(layer, mapIndex = DEFAULT_MAP) {
        return this.coreMapService.getExtraLayer(layer, mapIndex);
    }
    zoomToCoordinate(coord, mapIndex = DEFAULT_MAP, maxZoom) {
        return new Promise((resolve) => {
            if (this.coreMapService.checkMapIndex(mapIndex)) {
                const map = this.coreMapService.getMap(mapIndex);
                const zoom = () => {
                    map.getView().fit([...coord, ...coord], { maxZoom });
                    resolve(this.coreMapService.decideMapComponentEventType(true, mapIndex));
                };
                if (map.isRendered()) {
                    zoom();
                }
                else {
                    map.once("loadend", () => {
                        zoom();
                    });
                }
            }
            resolve(this.coreMapService.decideMapComponentEventType(false, mapIndex));
        });
    }
    zoomToGeometry(geometry, mapIndex = DEFAULT_MAP, maxZoom) {
        if (this.coreMapService.checkMapIndex(mapIndex)) {
            const geom = this.format.readGeometry(geometry);
            const extent = geom.getExtent();
            this.coreMapService.getMap(mapIndex).getView().fit(extent, { maxZoom });
            return this.coreMapService.decideMapComponentEventType(true, mapIndex);
        }
        return this.coreMapService.decideMapComponentEventType(false, mapIndex);
    }
    zoomToPdokResult(evt, mapIndex, maxZoom) {
        if (this.coreMapService.checkMapIndex(mapIndex)) {
            const coordinates = this.getCoordinatesFromEvent(evt);
            return coordinates
                ? this.zoomToGeometry(coordinates, mapIndex, maxZoom)
                : new MapComponentEvent(MapComponentEventTypes.UNSUCCESSFUL, mapIndex || DEFAULT_MAP, "Coordinaat voor zoomToPdokResult op de kaart kon niet worden bepaald");
        }
        return this.coreMapService.decideMapComponentEventType(false, mapIndex);
    }
    zoomToPdokResultAndSimulateClick(evt, mapIndex, maxZoom) {
        if (this.coreMapService.checkMapIndex(mapIndex)) {
            this.zoomToPdokResult(evt, mapIndex, maxZoom);
            const coordinate = this.getCentroidRdFromPdokResult(evt);
            if (!coordinate) {
                return new MapComponentEvent(MapComponentEventTypes.UNSUCCESSFUL, mapIndex || DEFAULT_MAP, "Coordinaat voor simuleren klik op de kaart kon niet worden bepaald");
            }
            else {
                const map = this.coreMapService.getMap(mapIndex);
                // het is niet mogelijk de ol.MapBrowserEvent constructor
                // te gebruiken vandaar deze manier van event creatie
                const browserEvent = {
                    type: "singleclick",
                    map: this.getMap(mapIndex),
                    coordinate,
                    pixel: map.getPixelFromCoordinate(coordinate),
                };
                map.dispatchEvent(browserEvent);
                return this.coreMapService.decideMapComponentEventType(true, mapIndex);
            }
        }
        return this.coreMapService.decideMapComponentEventType(false, mapIndex);
    }
    zoomToPdokResultAndMark(evt, mapIndex, maxZoom) {
        if (this.coreMapService.checkMapIndex(mapIndex)) {
            this.zoomToPdokResult(evt, mapIndex, maxZoom);
            const coordinates = this.getCoordinatesFromEvent(evt);
            if (coordinates) {
                const olFeature = this.format.readFeatures(coordinates);
                this.clearHighlightLayer(mapIndex);
                this.addFeaturesToHighlightLayer(olFeature, mapIndex);
                return this.coreMapService.decideMapComponentEventType(true, mapIndex);
            }
            else {
                return new MapComponentEvent(MapComponentEventTypes.UNSUCCESSFUL, mapIndex || DEFAULT_MAP, "Coordinaat voor zoomToPdokResultAndMark op de kaart kon niet worden bepaald");
            }
        }
        return this.coreMapService.decideMapComponentEventType(false, mapIndex);
    }
    getCentroidRdFromPdokResult(evt) {
        let coordinateRd;
        const pdokDoc = this.getSearchResultDocFromEvent(evt);
        if (pdokDoc) {
            const centroidRd = pdokDoc.centroide_rd;
            if (centroidRd) {
                // Een centroide is een punt, dus we weten dat het een point betreft, vandaar de cast.
                const point = this.format.readGeometry(centroidRd);
                coordinateRd = point.getCoordinates();
            }
        }
        return coordinateRd;
    }
    getGeometryFromPdokResult(evt) {
        let geometry;
        const pdokDoc = this.getSearchResultDocFromEvent(evt);
        if (pdokDoc) {
            const geometryRd = pdokDoc.geometrie_rd;
            if (geometryRd) {
                const readGeometry = this.format.readGeometry(geometryRd);
                geometry = readGeometry.getSimplifiedGeometry(0);
            }
        }
        return geometry;
    }
    addFeaturesToHighlightLayer(features, mapIndex = DEFAULT_MAP) {
        return this.coreMapService.addFeaturesToHighlightLayer(features, mapIndex);
    }
    clearHighlightLayer(mapIndex = DEFAULT_MAP) {
        return this.coreMapService.clearHighlightLayer(mapIndex);
    }
    changeHighlightLayerStyle(styleLike, mapIndex = DEFAULT_MAP) {
        this.coreMapService.changeHighlightLayerStyle(styleLike, mapIndex);
    }
    addFeaturesToSelectionLayer(features, mapIndex = DEFAULT_MAP) {
        return this.coreMapService.addFeaturesToSelectionLayer(features, mapIndex);
    }
    clearSelectionLayer(mapIndex = DEFAULT_MAP) {
        return this.coreMapService.clearSelectionLayer(mapIndex);
    }
    changeSelectionLayerStyle(styleLike, mapIndex = DEFAULT_MAP) {
        this.coreMapService.changeSelectionLayerStyle(styleLike, mapIndex);
    }
    isMaxZoomlevel(mapIndex = DEFAULT_MAP) {
        const view = this.coreMapService.getMap(mapIndex).getView();
        return view.getZoom() === view.getMaxZoom();
    }
    getGeometrieOrCentroide(pdokDoc) {
        if (pdokDoc.geometrie_rd) {
            return pdokDoc.geometrie_rd;
        }
        if (pdokDoc.centroide_rd) {
            return pdokDoc.centroide_rd;
        }
    }
    getSearchResultDocFromEvent(evt) {
        let pdokDoc;
        if (evt.value && evt.value.docs && evt.value.docs.length > 0) {
            pdokDoc = evt.value.docs[0];
        }
        return pdokDoc;
    }
    getCoordinatesFromEvent(evt) {
        let coordinates;
        const pdokDoc = this.getSearchResultDocFromEvent(evt);
        if (pdokDoc) {
            const geometrieOrCentroide = this.getGeometrieOrCentroide(pdokDoc);
            if (geometrieOrCentroide) {
                coordinates = geometrieOrCentroide;
            }
        }
        return coordinates;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: MapService, deps: [{ token: CoreMapService }, { token: EXTRA_LAYERS, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: MapService, providedIn: "root" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: MapService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: function () { return [{ type: CoreMapService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [EXTRA_LAYERS]
                }, {
                    type: Optional
                }] }]; } });

class ToolbarComponent {
    constructor(mapService) {
        this.mapService = mapService;
        this.mapName = DEFAULT_MAP;
    }
    ngOnInit() {
        this.map = this.mapService.getMap(this.mapName);
    }
    ngAfterViewInit() {
        this.children.forEach((child) => {
            child.activeChanged.subscribe((event) => {
                if (event.active) {
                    this.toolbarContentTemplate =
                        event.toolbarItemComponent.toolbarItemTemplate;
                    this.inactivateOtherChildren(event.toolbarItemComponent);
                }
                else {
                    this.toolbarContentTemplate = undefined;
                }
            });
        });
    }
    inactivateOtherChildren(activeItem) {
        this.children
            .filter((child) => child !== activeItem)
            .forEach((child) => (child.active = false));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: ToolbarComponent, deps: [{ token: MapService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.3", type: ToolbarComponent, selector: "ggc-toolbar", inputs: { mapName: "mapName" }, queries: [{ propertyName: "children", predicate: ToolbarItemComponent }], ngImport: i0, template: "<section class=\"ggc-toolbar-items\" aria-label=\"kaart-tools\">\n  <div class=\"card card-tools\">\n    <div class=\"card-header\">\n      <div class=\"nav nav-tabs\" role=\"tablist\">\n        <ng-content></ng-content>\n      </div>\n    </div>\n    <ng-container *ngTemplateOutlet=\"toolbarContentTemplate\"></ng-container>\n  </div>\n</section>\n", styles: [".ggc-toolbar-items{display:inline-block}\n"], dependencies: [{ kind: "directive", type: i2$1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: ToolbarComponent, decorators: [{
            type: Component,
            args: [{ selector: "ggc-toolbar", template: "<section class=\"ggc-toolbar-items\" aria-label=\"kaart-tools\">\n  <div class=\"card card-tools\">\n    <div class=\"card-header\">\n      <div class=\"nav nav-tabs\" role=\"tablist\">\n        <ng-content></ng-content>\n      </div>\n    </div>\n    <ng-container *ngTemplateOutlet=\"toolbarContentTemplate\"></ng-container>\n  </div>\n</section>\n", styles: [".ggc-toolbar-items{display:inline-block}\n"] }]
        }], ctorParameters: function () { return [{ type: MapService }]; }, propDecorators: { mapName: [{
                type: Input
            }], children: [{
                type: ContentChildren,
                args: [ToolbarItemComponent]
            }] } });

var ToolbarItemDrawType;
(function (ToolbarItemDrawType) {
    ToolbarItemDrawType["STOP"] = "stop";
    ToolbarItemDrawType["MOVE"] = "move";
    ToolbarItemDrawType["EDIT"] = "edit";
    ToolbarItemDrawType["POINT"] = "point";
    ToolbarItemDrawType["LINE"] = "line";
    ToolbarItemDrawType["CIRCLE"] = "circle";
    ToolbarItemDrawType["RECTANGLE"] = "rectangle";
    ToolbarItemDrawType["POLYGON"] = "polygon";
    ToolbarItemDrawType["CLEAR"] = "clear";
})(ToolbarItemDrawType || (ToolbarItemDrawType = {}));
class ToolbarItemDrawComponentEvent {
}

class DrawService {
    constructor(coreDrawService) {
        this.coreDrawService = coreDrawService;
    }
    addFeatureToLayer(layerName, feature, mapIndex = DEFAULT_MAP) {
        return this.coreDrawService.addFeatureToLayer(layerName, mapIndex, feature);
    }
    clearLayer(layerName, mapIndex = DEFAULT_MAP) {
        this.coreDrawService.clearLayer(layerName, mapIndex);
    }
    deleteLayer(layerName, mapIndex = DEFAULT_MAP) {
        this.coreDrawService.deleteLayer(layerName, mapIndex);
    }
    finishCurrentDraw(mapIndex = DEFAULT_MAP) {
        this.coreDrawService.finishCurrentDraw(mapIndex);
    }
    getDrawEventsObservable(mapIndex = DEFAULT_MAP) {
        return this.coreDrawService.getDrawObservable(mapIndex);
    }
    getModifyEventsObservable(mapIndex = DEFAULT_MAP) {
        return this.coreDrawService.getModifyEventsObservable(mapIndex);
    }
    getMeasureEventsObservable(mapIndex = DEFAULT_MAP) {
        return this.coreDrawService.getMeasureEventsObservable(mapIndex);
    }
    getFeaturesFromLayer(layerName, mapIndex = DEFAULT_MAP) {
        const layer = this.coreDrawService.getDrawLayer(layerName, mapIndex);
        return layer.getSource().getFeatures();
    }
    isLayerVisible(layerName, mapIndex = DEFAULT_MAP) {
        const layer = this.coreDrawService.getDrawLayer(layerName, mapIndex);
        return layer.getVisible();
    }
    setDrawStyle(layerName, styleLikeMap, mapIndex = DEFAULT_MAP) {
        this.coreDrawService.setDrawStyle(layerName, mapIndex, styleLikeMap);
    }
    setLayerVisibility(layerName, visible, mapIndex = DEFAULT_MAP) {
        this.coreDrawService.setLayerVisibility(layerName, mapIndex, visible);
    }
    setLayerZIndex(zIndex, layerName, mapIndex = DEFAULT_MAP) {
        this.coreDrawService.setLayerZIndex(layerName, mapIndex, zIndex);
    }
    startDraw(layerName, drawType, drawOptions, mapIndex = DEFAULT_MAP) {
        this.coreDrawService.startDraw(layerName, mapIndex, drawType, drawOptions);
    }
    startModify(layerName, mapIndex = DEFAULT_MAP, drawOptions = {}, deleteCondition, insertVertexCondition) {
        this.coreDrawService.startModify(layerName, mapIndex, drawOptions, deleteCondition, insertVertexCondition);
    }
    startMove(layerName, mapIndex = DEFAULT_MAP, drawOptions = {}) {
        this.coreDrawService.startMove(layerName, mapIndex, drawOptions);
    }
    stopMove(mapIndex = DEFAULT_MAP) {
        this.coreDrawService.stopMove(mapIndex);
    }
    startSnap(layerName, mapIndex = DEFAULT_MAP) {
        this.coreDrawService.startSnap(layerName, mapIndex);
    }
    stopDraw(mapIndex = DEFAULT_MAP) {
        this.coreDrawService.stopDraw(mapIndex);
    }
    stopDrawAndClearLayer(layerName, mapIndex = DEFAULT_MAP) {
        this.stopDraw(mapIndex);
        this.clearLayer(layerName, mapIndex);
        this.coreDrawService.deleteLayer(layerName, mapIndex);
    }
    stopModify(mapIndex = DEFAULT_MAP) {
        this.coreDrawService.stopModify(mapIndex);
    }
    stopSnap(mapIndex = DEFAULT_MAP) {
        this.coreDrawService.stopSnap(mapIndex);
    }
    toggleLayer(layerName, mapIndex = DEFAULT_MAP) {
        this.coreDrawService.toggleLayer(layerName, mapIndex);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: DrawService, deps: [{ token: CoreDrawService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: DrawService, providedIn: "root" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: DrawService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: function () { return [{ type: CoreDrawService }]; } });

class ToolbarItemDrawComponent {
    constructor(drawService) {
        this.drawService = drawService;
        this.mapName = DEFAULT_MAP;
        this.layer = "drawing";
        this.stopIcon = "fal fa-mouse-pointer";
        this.drawIcon = "fas fa-circle";
        this.drawLineIcon = "fal fa-project-diagram";
        this.drawCircleIcon = "fal fa-dot-circle";
        this.drawRectangleIcon = "fal fa-vector-square";
        this.drawPolygonIcon = "fal fa-draw-polygon";
        this.deleteIcon = "fal fa-trash-alt";
        this.moveIcon = "fal fa-hand-paper";
        this.editIcon = "fal fa-pencil-alt";
        this.drawItemClicked = new EventEmitter();
    }
    draw(type) {
        this.activeDraw = type;
        this.drawService.startDraw(this.layer, this.getMapComponentDrawType(type), {}, this.mapName);
        this.drawItemClicked.emit({
            toolbarItemName: this.getToolbarItemDrawType(type),
        });
    }
    move() {
        this.activeDraw = "move";
        this.drawService.startMove(this.layer, this.mapName);
        this.drawItemClicked.emit({ toolbarItemName: ToolbarItemDrawType.MOVE });
    }
    edit() {
        this.activeDraw = "edit";
        this.drawService.startModify(this.layer, this.mapName);
        this.drawItemClicked.emit({ toolbarItemName: ToolbarItemDrawType.EDIT });
    }
    getMapComponentDrawType(type) {
        switch (type) {
            case "Circle":
                return MapComponentDrawTypes.CIRCLE;
            case "Line":
                return MapComponentDrawTypes.LINESTRING;
            case "Point":
                return MapComponentDrawTypes.POINT;
            case "Rectangle":
                return MapComponentDrawTypes.RECTANGLE;
            default:
                return MapComponentDrawTypes.POLYGON;
        }
    }
    getToolbarItemDrawType(type) {
        switch (type) {
            case "Circle":
                return ToolbarItemDrawType.POLYGON;
            case "Line":
                return ToolbarItemDrawType.LINE;
            case "Point":
                return ToolbarItemDrawType.POINT;
            case "Rectangle":
                return ToolbarItemDrawType.RECTANGLE;
            default:
                return ToolbarItemDrawType.POLYGON;
        }
    }
    stopDrawing() {
        this.activeDraw = undefined;
        this.drawService.stopDraw(this.mapName);
        this.drawItemClicked.emit({ toolbarItemName: ToolbarItemDrawType.STOP });
    }
    eraseDrawLayer() {
        this.activeDraw = undefined;
        this.drawService.clearLayer(this.layer, this.mapName);
        this.drawItemClicked.emit({ toolbarItemName: ToolbarItemDrawType.CLEAR });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: ToolbarItemDrawComponent, deps: [{ token: DrawService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.3", type: ToolbarItemDrawComponent, selector: "ggc-toolbar-item-draw", inputs: { mapName: "mapName", layer: "layer", stopIcon: "stopIcon", drawIcon: "drawIcon", drawLineIcon: "drawLineIcon", drawCircleIcon: "drawCircleIcon", drawRectangleIcon: "drawRectangleIcon", drawPolygonIcon: "drawPolygonIcon", deleteIcon: "deleteIcon", moveIcon: "moveIcon", editIcon: "editIcon" }, outputs: { drawItemClicked: "drawItemClicked" }, ngImport: i0, template: "<ul class=\"card-tools-btn-list\" role=\"menubar\">\n  <li class=\"card-tools-btn-list-item\">\n    <button\n      type=\"button\"\n      class=\"btn btn-tools stop\"\n      aria-label=\"Stop tekenen\"\n      title=\"Stop tekenen\"\n      (click)=\"stopDrawing()\"\n    >\n      <span [ngClass]=\"stopIcon\" aria-hidden=\"true\"></span>\n    </button>\n  </li>\n  <li class=\"card-tools-btn-list-item\">\n    <button\n      type=\"button\"\n      class=\"btn btn-tools point\"\n      aria-label=\"Punt tekenen\"\n      [ngClass]=\"{ active: activeDraw === 'Point' }\"\n      title=\"Punt tekenen\"\n      (click)=\"draw('Point')\"\n    >\n      <span [ngClass]=\"drawIcon\" aria-hidden=\"true\"></span>\n    </button>\n  </li>\n  <li class=\"card-tools-btn-list-item\">\n    <button\n      type=\"button\"\n      class=\"btn btn-tools line\"\n      aria-label=\"Lijn tekenen\"\n      [ngClass]=\"{ active: activeDraw === 'Line' }\"\n      title=\"Lijn tekenen\"\n      (click)=\"draw('Line')\"\n    >\n      <span [ngClass]=\"drawLineIcon\" aria-hidden=\"true\"></span>\n    </button>\n  </li>\n  <li class=\"card-tools-btn-list-item\">\n    <button\n      type=\"button\"\n      class=\"btn btn-tools circle\"\n      aria-label=\"Cirkel tekenen\"\n      [ngClass]=\"{ active: activeDraw === 'Circle' }\"\n      title=\"Cirkel tekenen\"\n      (click)=\"draw('Circle')\"\n    >\n      <span [ngClass]=\"drawCircleIcon\" aria-hidden=\"true\"></span>\n    </button>\n  </li>\n  <li class=\"card-tools-btn-list-item\">\n    <button\n      type=\"button\"\n      class=\"btn btn-tools square\"\n      aria-label=\"Rechthoek tekenen\"\n      [ngClass]=\"{ active: activeDraw === 'Rectangle' }\"\n      title=\"Rechthoek tekenen\"\n      (click)=\"draw('Rectangle')\"\n    >\n      <span [ngClass]=\"drawRectangleIcon\" aria-hidden=\"true\"></span>\n    </button>\n  </li>\n  <li class=\"card-tools-btn-list-item\">\n    <button\n      type=\"button\"\n      class=\"btn btn-tools polygon\"\n      aria-label=\"Vlak tekenen\"\n      [ngClass]=\"{ active: activeDraw === 'Polygon' }\"\n      title=\"Vlak tekenen\"\n      (click)=\"draw('Polygon')\"\n    >\n      <span [ngClass]=\"drawPolygonIcon\" aria-hidden=\"true\"></span>\n    </button>\n  </li>\n  <li class=\"card-tools-btn-list-item\">\n    <button\n      type=\"button\"\n      class=\"btn btn-tools move\"\n      [ngClass]=\"{ active: activeDraw === 'move' }\"\n      aria-label=\"Tekening verplaatsen\"\n      title=\"Tekening verplaatsen\"\n      (click)=\"move()\"\n    >\n      <span [ngClass]=\"moveIcon\" aria-hidden=\"true\"></span>\n    </button>\n  </li>\n  <li class=\"card-tools-btn-list-item\">\n    <button\n      type=\"button\"\n      class=\"btn btn-tools edit\"\n      [ngClass]=\"{ active: activeDraw === 'edit' }\"\n      aria-label=\"Tekening bewerken\"\n      title=\"Tekening bewerken\"\n      (click)=\"edit()\"\n    >\n      <span [ngClass]=\"editIcon\" aria-hidden=\"true\"></span>\n    </button>\n  </li>\n  <li class=\"card-tools-btn-list-item\">\n    <button\n      type=\"button\"\n      class=\"btn btn-tools erase\"\n      aria-label=\"Tekening wissen\"\n      title=\"Tekening wissen\"\n      (click)=\"eraseDrawLayer()\"\n    >\n      <span [ngClass]=\"deleteIcon\" aria-hidden=\"true\"></span>\n    </button>\n  </li>\n</ul>\n", styles: [".card-tools-btn-list{list-style:none;display:flex;flex-wrap:wrap}\n"], dependencies: [{ kind: "directive", type: i2$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: ToolbarItemDrawComponent, decorators: [{
            type: Component,
            args: [{ selector: "ggc-toolbar-item-draw", template: "<ul class=\"card-tools-btn-list\" role=\"menubar\">\n  <li class=\"card-tools-btn-list-item\">\n    <button\n      type=\"button\"\n      class=\"btn btn-tools stop\"\n      aria-label=\"Stop tekenen\"\n      title=\"Stop tekenen\"\n      (click)=\"stopDrawing()\"\n    >\n      <span [ngClass]=\"stopIcon\" aria-hidden=\"true\"></span>\n    </button>\n  </li>\n  <li class=\"card-tools-btn-list-item\">\n    <button\n      type=\"button\"\n      class=\"btn btn-tools point\"\n      aria-label=\"Punt tekenen\"\n      [ngClass]=\"{ active: activeDraw === 'Point' }\"\n      title=\"Punt tekenen\"\n      (click)=\"draw('Point')\"\n    >\n      <span [ngClass]=\"drawIcon\" aria-hidden=\"true\"></span>\n    </button>\n  </li>\n  <li class=\"card-tools-btn-list-item\">\n    <button\n      type=\"button\"\n      class=\"btn btn-tools line\"\n      aria-label=\"Lijn tekenen\"\n      [ngClass]=\"{ active: activeDraw === 'Line' }\"\n      title=\"Lijn tekenen\"\n      (click)=\"draw('Line')\"\n    >\n      <span [ngClass]=\"drawLineIcon\" aria-hidden=\"true\"></span>\n    </button>\n  </li>\n  <li class=\"card-tools-btn-list-item\">\n    <button\n      type=\"button\"\n      class=\"btn btn-tools circle\"\n      aria-label=\"Cirkel tekenen\"\n      [ngClass]=\"{ active: activeDraw === 'Circle' }\"\n      title=\"Cirkel tekenen\"\n      (click)=\"draw('Circle')\"\n    >\n      <span [ngClass]=\"drawCircleIcon\" aria-hidden=\"true\"></span>\n    </button>\n  </li>\n  <li class=\"card-tools-btn-list-item\">\n    <button\n      type=\"button\"\n      class=\"btn btn-tools square\"\n      aria-label=\"Rechthoek tekenen\"\n      [ngClass]=\"{ active: activeDraw === 'Rectangle' }\"\n      title=\"Rechthoek tekenen\"\n      (click)=\"draw('Rectangle')\"\n    >\n      <span [ngClass]=\"drawRectangleIcon\" aria-hidden=\"true\"></span>\n    </button>\n  </li>\n  <li class=\"card-tools-btn-list-item\">\n    <button\n      type=\"button\"\n      class=\"btn btn-tools polygon\"\n      aria-label=\"Vlak tekenen\"\n      [ngClass]=\"{ active: activeDraw === 'Polygon' }\"\n      title=\"Vlak tekenen\"\n      (click)=\"draw('Polygon')\"\n    >\n      <span [ngClass]=\"drawPolygonIcon\" aria-hidden=\"true\"></span>\n    </button>\n  </li>\n  <li class=\"card-tools-btn-list-item\">\n    <button\n      type=\"button\"\n      class=\"btn btn-tools move\"\n      [ngClass]=\"{ active: activeDraw === 'move' }\"\n      aria-label=\"Tekening verplaatsen\"\n      title=\"Tekening verplaatsen\"\n      (click)=\"move()\"\n    >\n      <span [ngClass]=\"moveIcon\" aria-hidden=\"true\"></span>\n    </button>\n  </li>\n  <li class=\"card-tools-btn-list-item\">\n    <button\n      type=\"button\"\n      class=\"btn btn-tools edit\"\n      [ngClass]=\"{ active: activeDraw === 'edit' }\"\n      aria-label=\"Tekening bewerken\"\n      title=\"Tekening bewerken\"\n      (click)=\"edit()\"\n    >\n      <span [ngClass]=\"editIcon\" aria-hidden=\"true\"></span>\n    </button>\n  </li>\n  <li class=\"card-tools-btn-list-item\">\n    <button\n      type=\"button\"\n      class=\"btn btn-tools erase\"\n      aria-label=\"Tekening wissen\"\n      title=\"Tekening wissen\"\n      (click)=\"eraseDrawLayer()\"\n    >\n      <span [ngClass]=\"deleteIcon\" aria-hidden=\"true\"></span>\n    </button>\n  </li>\n</ul>\n", styles: [".card-tools-btn-list{list-style:none;display:flex;flex-wrap:wrap}\n"] }]
        }], ctorParameters: function () { return [{ type: DrawService }]; }, propDecorators: { mapName: [{
                type: Input
            }], layer: [{
                type: Input
            }], stopIcon: [{
                type: Input
            }], drawIcon: [{
                type: Input
            }], drawLineIcon: [{
                type: Input
            }], drawCircleIcon: [{
                type: Input
            }], drawRectangleIcon: [{
                type: Input
            }], drawPolygonIcon: [{
                type: Input
            }], deleteIcon: [{
                type: Input
            }], moveIcon: [{
                type: Input
            }], editIcon: [{
                type: Input
            }], drawItemClicked: [{
                type: Output
            }] } });

var ToolbarItemMeasureType;
(function (ToolbarItemMeasureType) {
    ToolbarItemMeasureType["EDIT"] = "edit";
    ToolbarItemMeasureType["MOVE"] = "move";
    ToolbarItemMeasureType["STOP"] = "stop";
    ToolbarItemMeasureType["LINE"] = "line";
    ToolbarItemMeasureType["POLYGON"] = "polygon";
    ToolbarItemMeasureType["CLEAR"] = "clear";
})(ToolbarItemMeasureType || (ToolbarItemMeasureType = {}));
class ToolbarItemMeasureComponentEvent {
}

class ToolbarItemMeasureComponent {
    constructor(drawService) {
        this.drawService = drawService;
        this.mapName = DEFAULT_MAP;
        this.layer = "measuring";
        this.stopIcon = "fal fa-mouse-pointer";
        this.measureLineIcon = "fal fa-ruler-horizontal";
        this.measurePolygonIcon = "fal fa-ruler-combined";
        this.deleteIcon = "fal fa-trash-alt";
        this.moveIcon = "fal fa-hand-paper";
        this.editIcon = "fal fa-pencil-alt";
        this.measureItemClicked = new EventEmitter();
        this.resetActive();
    }
    measureLine() {
        this.resetActive();
        this.activeMeasure = "line";
        this.drawService.startDraw(this.layer, MapComponentDrawTypes.LINESTRING, { showTotalLength: true }, this.mapName);
        this.measureItemClicked.emit({
            toolbarItemName: ToolbarItemMeasureType.LINE,
        });
    }
    measurePolygon() {
        this.resetActive();
        this.activeMeasure = "polygon";
        this.drawService.startDraw(this.layer, MapComponentDrawTypes.POLYGON, { showArea: true }, this.mapName);
        this.measureItemClicked.emit({
            toolbarItemName: ToolbarItemMeasureType.POLYGON,
        });
    }
    stopMeasure() {
        this.resetActive();
        this.drawService.stopDraw(this.mapName);
        this.measureItemClicked.emit({
            toolbarItemName: ToolbarItemMeasureType.STOP,
        });
    }
    move() {
        this.activeMeasure = "move";
        this.drawService.startMove(this.layer, this.mapName);
        this.measureItemClicked.emit({
            toolbarItemName: ToolbarItemMeasureType.MOVE,
        });
    }
    edit() {
        this.activeMeasure = "edit";
        this.drawService.startModify(this.layer, this.mapName);
        this.measureItemClicked.emit({
            toolbarItemName: ToolbarItemMeasureType.EDIT,
        });
    }
    eraseMeasureLayer() {
        this.resetActive();
        this.drawService.clearLayer(this.layer, this.mapName);
        this.measureItemClicked.emit({
            toolbarItemName: ToolbarItemMeasureType.CLEAR,
        });
    }
    resetActive() {
        this.activeMeasure = undefined;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: ToolbarItemMeasureComponent, deps: [{ token: DrawService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.3", type: ToolbarItemMeasureComponent, selector: "ggc-toolbar-item-measure", inputs: { mapName: "mapName", layer: "layer", stopIcon: "stopIcon", measureLineIcon: "measureLineIcon", measurePolygonIcon: "measurePolygonIcon", deleteIcon: "deleteIcon", moveIcon: "moveIcon", editIcon: "editIcon" }, outputs: { measureItemClicked: "measureItemClicked" }, ngImport: i0, template: "<ul class=\"card-tools-btn-list\" role=\"menubar\">\n  <li class=\"card-tools-btn-list-item\">\n    <button\n      type=\"button\"\n      class=\"btn btn-tools stop\"\n      aria-label=\"Stop meten\"\n      title=\"Stop meten\"\n      (click)=\"stopMeasure()\"\n    >\n      <span [ngClass]=\"stopIcon\" aria-hidden=\"true\"></span>\n    </button>\n  </li>\n  <li class=\"card-tools-btn-list-item\">\n    <button\n      type=\"button\"\n      class=\"btn btn-tools point\"\n      aria-label=\"Lengte meten\"\n      title=\"Lengte meten\"\n      [ngClass]=\"{ active: activeMeasure === 'line' }\"\n      (click)=\"measureLine()\"\n    >\n      <span [ngClass]=\"measureLineIcon\" aria-hidden=\"true\"></span>\n    </button>\n  </li>\n  <li class=\"card-tools-btn-list-item\">\n    <button\n      type=\"button\"\n      class=\"btn btn-tools line\"\n      aria-label=\"Oppervlakte meten\"\n      title=\"Oppervlakte meten\"\n      [ngClass]=\"{ active: activeMeasure === 'polygon' }\"\n      (click)=\"measurePolygon()\"\n    >\n      <span [ngClass]=\"measurePolygonIcon\" aria-hidden=\"true\"></span>\n    </button>\n  </li>\n  <li class=\"card-tools-btn-list-item\">\n    <button\n      type=\"button\"\n      class=\"btn btn-tools move\"\n      [ngClass]=\"{ active: activeMeasure === 'move' }\"\n      aria-label=\"Meting verplaatsen\"\n      title=\"Meting verplaatsen\"\n      (click)=\"move()\"\n    >\n      <span [ngClass]=\"moveIcon\" aria-hidden=\"true\"></span>\n    </button>\n  </li>\n  <li class=\"card-tools-btn-list-item\">\n    <button\n      type=\"button\"\n      class=\"btn btn-tools edit\"\n      [ngClass]=\"{ active: activeMeasure === 'edit' }\"\n      aria-label=\"Meting bewerken\"\n      title=\"Meting bewerken\"\n      (click)=\"edit()\"\n    >\n      <span [ngClass]=\"editIcon\" aria-hidden=\"true\"></span>\n    </button>\n  </li>\n  <li class=\"card-tools-btn-list-item\">\n    <button\n      type=\"button\"\n      class=\"btn btn-tools circle\"\n      aria-label=\"Meting wissen\"\n      title=\"Meting wissen\"\n      (click)=\"eraseMeasureLayer()\"\n    >\n      <span [ngClass]=\"deleteIcon\" aria-hidden=\"true\"></span>\n    </button>\n  </li>\n</ul>\n", styles: [".card-tools-btn-list{list-style:none;display:flex;flex-wrap:wrap}\n"], dependencies: [{ kind: "directive", type: i2$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: ToolbarItemMeasureComponent, decorators: [{
            type: Component,
            args: [{ selector: "ggc-toolbar-item-measure", template: "<ul class=\"card-tools-btn-list\" role=\"menubar\">\n  <li class=\"card-tools-btn-list-item\">\n    <button\n      type=\"button\"\n      class=\"btn btn-tools stop\"\n      aria-label=\"Stop meten\"\n      title=\"Stop meten\"\n      (click)=\"stopMeasure()\"\n    >\n      <span [ngClass]=\"stopIcon\" aria-hidden=\"true\"></span>\n    </button>\n  </li>\n  <li class=\"card-tools-btn-list-item\">\n    <button\n      type=\"button\"\n      class=\"btn btn-tools point\"\n      aria-label=\"Lengte meten\"\n      title=\"Lengte meten\"\n      [ngClass]=\"{ active: activeMeasure === 'line' }\"\n      (click)=\"measureLine()\"\n    >\n      <span [ngClass]=\"measureLineIcon\" aria-hidden=\"true\"></span>\n    </button>\n  </li>\n  <li class=\"card-tools-btn-list-item\">\n    <button\n      type=\"button\"\n      class=\"btn btn-tools line\"\n      aria-label=\"Oppervlakte meten\"\n      title=\"Oppervlakte meten\"\n      [ngClass]=\"{ active: activeMeasure === 'polygon' }\"\n      (click)=\"measurePolygon()\"\n    >\n      <span [ngClass]=\"measurePolygonIcon\" aria-hidden=\"true\"></span>\n    </button>\n  </li>\n  <li class=\"card-tools-btn-list-item\">\n    <button\n      type=\"button\"\n      class=\"btn btn-tools move\"\n      [ngClass]=\"{ active: activeMeasure === 'move' }\"\n      aria-label=\"Meting verplaatsen\"\n      title=\"Meting verplaatsen\"\n      (click)=\"move()\"\n    >\n      <span [ngClass]=\"moveIcon\" aria-hidden=\"true\"></span>\n    </button>\n  </li>\n  <li class=\"card-tools-btn-list-item\">\n    <button\n      type=\"button\"\n      class=\"btn btn-tools edit\"\n      [ngClass]=\"{ active: activeMeasure === 'edit' }\"\n      aria-label=\"Meting bewerken\"\n      title=\"Meting bewerken\"\n      (click)=\"edit()\"\n    >\n      <span [ngClass]=\"editIcon\" aria-hidden=\"true\"></span>\n    </button>\n  </li>\n  <li class=\"card-tools-btn-list-item\">\n    <button\n      type=\"button\"\n      class=\"btn btn-tools circle\"\n      aria-label=\"Meting wissen\"\n      title=\"Meting wissen\"\n      (click)=\"eraseMeasureLayer()\"\n    >\n      <span [ngClass]=\"deleteIcon\" aria-hidden=\"true\"></span>\n    </button>\n  </li>\n</ul>\n", styles: [".card-tools-btn-list{list-style:none;display:flex;flex-wrap:wrap}\n"] }]
        }], ctorParameters: function () { return [{ type: DrawService }]; }, propDecorators: { mapName: [{
                type: Input
            }], layer: [{
                type: Input
            }], stopIcon: [{
                type: Input
            }], measureLineIcon: [{
                type: Input
            }], measurePolygonIcon: [{
                type: Input
            }], deleteIcon: [{
                type: Input
            }], moveIcon: [{
                type: Input
            }], editIcon: [{
                type: Input
            }], measureItemClicked: [{
                type: Output
            }] } });

class ToolbarModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: ToolbarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.3", ngImport: i0, type: ToolbarModule, declarations: [ToolbarComponent,
            ToolbarItemComponent,
            ToolbarItemDrawComponent,
            ToolbarItemMeasureComponent], imports: [CommonModule], exports: [ToolbarComponent,
            ToolbarItemComponent,
            ToolbarItemDrawComponent,
            ToolbarItemMeasureComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: ToolbarModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: ToolbarModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [
                        ToolbarComponent,
                        ToolbarItemComponent,
                        ToolbarItemDrawComponent,
                        ToolbarItemMeasureComponent,
                    ],
                    exports: [
                        ToolbarComponent,
                        ToolbarItemComponent,
                        ToolbarItemDrawComponent,
                        ToolbarItemMeasureComponent,
                    ],
                }]
        }] });

class ZoomLevelComponent {
    constructor(coreMapService, mapEventsService) {
        this.coreMapService = coreMapService;
        this.mapEventsService = mapEventsService;
        this.mapName = DEFAULT_MAP;
    }
    ngOnInit() {
        this.map = this.coreMapService.getMap(this.mapName);
        const zoomendObservable = this.mapEventsService.getZoomendObservableForMap(this.mapName);
        this.zoomendSubscription = zoomendObservable.subscribe(() => {
            this.getZoomLevel();
        });
    }
    getZoomLevel() {
        const zoomLevel = this.map.getView().getZoom();
        if (zoomLevel) {
            this.zoomLevel = Math.round(zoomLevel * 100) / 100;
        }
        else {
            this.zoomLevel = undefined;
        }
    }
    ngOnDestroy() {
        if (this.zoomendSubscription) {
            this.zoomendSubscription.unsubscribe();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: ZoomLevelComponent, deps: [{ token: CoreMapService }, { token: CoreMapEventsService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.3", type: ZoomLevelComponent, isStandalone: true, selector: "ggc-zoom-level", inputs: { mapName: "mapName" }, ngImport: i0, template: "<div *ngIf=\"zoomLevel !== undefined\" class=\"ggc-zoom-level\">\n  {{ zoomLevel }}\n</div>\n", dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: ZoomLevelComponent, decorators: [{
            type: Component,
            args: [{ selector: "ggc-zoom-level", standalone: true, imports: [NgIf], template: "<div *ngIf=\"zoomLevel !== undefined\" class=\"ggc-zoom-level\">\n  {{ zoomLevel }}\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: CoreMapService }, { type: CoreMapEventsService }]; }, propDecorators: { mapName: [{
                type: Input
            }] } });

class ZoomLevelModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: ZoomLevelModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.3", ngImport: i0, type: ZoomLevelModule, imports: [CommonModule, ZoomLevelComponent], exports: [ZoomLevelComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: ZoomLevelModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: ZoomLevelModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, ZoomLevelComponent],
                    exports: [ZoomLevelComponent],
                }]
        }] });

const modules = [
    MapModule,
    MousePositionModule,
    LayerModule,
    LoaderModule,
    ScaleLineModule,
    ScaleDenominatorModule,
    MapDetailsContainerModule,
    ZoomLevelModule,
    ToolbarModule,
];
class GgcMapRootModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: GgcMapRootModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.3", ngImport: i0, type: GgcMapRootModule, imports: [MapModule, DrawInteractionModule, SelectionModule, LayerModule], exports: [MapModule,
            MousePositionModule,
            LayerModule,
            LoaderModule,
            ScaleLineModule,
            ScaleDenominatorModule,
            MapDetailsContainerModule,
            ZoomLevelModule,
            ToolbarModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: GgcMapRootModule, imports: [MapModule, DrawInteractionModule, SelectionModule, LayerModule, MapModule,
            MousePositionModule,
            LayerModule,
            LoaderModule,
            ScaleLineModule,
            ScaleDenominatorModule,
            MapDetailsContainerModule,
            ZoomLevelModule,
            ToolbarModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: GgcMapRootModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [MapModule, DrawInteractionModule, SelectionModule, LayerModule],
                    exports: [modules],
                }]
        }] });
class GgcMapModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: GgcMapModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.3", ngImport: i0, type: GgcMapModule, declarations: [CoordinateFormatPipe], imports: [MapModule,
            MousePositionModule,
            LayerModule,
            LoaderModule,
            ScaleLineModule,
            ScaleDenominatorModule,
            MapDetailsContainerModule,
            ZoomLevelModule,
            ToolbarModule], exports: [MapModule,
            MousePositionModule,
            LayerModule,
            LoaderModule,
            ScaleLineModule,
            ScaleDenominatorModule,
            MapDetailsContainerModule,
            ZoomLevelModule,
            ToolbarModule, CoordinateFormatPipe] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: GgcMapModule, imports: [modules, MapModule,
            MousePositionModule,
            LayerModule,
            LoaderModule,
            ScaleLineModule,
            ScaleDenominatorModule,
            MapDetailsContainerModule,
            ZoomLevelModule,
            ToolbarModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: GgcMapModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [modules],
                    exports: [...modules, CoordinateFormatPipe],
                    declarations: [CoordinateFormatPipe],
                }]
        }] });

class SelectionService {
    constructor(coreSelectionService) {
        this.coreSelectionService = coreSelectionService;
    }
    setSingleselectMode(mapIndex = DEFAULT_MAP) {
        this.coreSelectionService.setSelectionModeForMapName(SelectionModeTypes.SINGLE_SELECT, mapIndex);
    }
    setMultiselectMode(mapIndex = DEFAULT_MAP) {
        this.coreSelectionService.setSelectionModeForMapName(SelectionModeTypes.MULTI_SELECT, mapIndex);
    }
    clearSelection(mapIndex = DEFAULT_MAP) {
        this.coreSelectionService.clearSelectionForMap(mapIndex);
    }
    setSelectionForLayer(features, layerName, mapIndex = DEFAULT_MAP) {
        this.coreSelectionService.setSelectionForLayer(features, layerName, mapIndex);
    }
    getObservable(mapIndex = DEFAULT_MAP) {
        return this.coreSelectionService.getObservableForMap(mapIndex);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: SelectionService, deps: [{ token: CoreSelectionService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: SelectionService, providedIn: "root" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.3", ngImport: i0, type: SelectionService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: function () { return [{ type: CoreSelectionService }]; } });

class ToolbarItemComponentEvent {
}

const featureCollectionForLayerHasCluster = (featureinfo) => {
    return featureinfo.features.some((feature) => feature.get("features") && feature.get("features").length > 1);
};
const declusterFeatures = (features) => {
    return features.reduce((previousValue, currentValue) => {
        const containedFeatures = currentValue.get("features") || [];
        return previousValue.concat(containedFeatures);
    }, []);
};

/*
 * Public API Surface of ggc-map
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ATTRIBUTION_OPTIONS, CoordinateFormatPipe, CrsConfigService, DEFAULT_MAP, DrawInteractionEvent, DrawInteractionEventTypes, DrawService, DrawingMode, EXTRA_LAYERS, FeatureCollectionForCoordinate, FeatureCollectionForLayer, GeojsonLayerComponent, GgcMapModule, ImageLayerComponent, LayerBrtAchtergrondkaartComponent, LayerModule, LoaderComponent, LoaderModule, MapComponent, MapComponentDrawTypes, MapComponentEvent, MapComponentEventTypes, MapDetailsContainerComponent, MapDetailsContainerModule, MapModule, MapService, MapViewState, MeasureEvent, MeasureEventTypes, ModifyInteractionEvent, ModifyInteractionEventTypes, MousePositionComponent, MousePositionModule, ObservableMapWrapper, ROTATE_OPTIONS, ScaleDenominatorComponent, ScaleDenominatorModule, ScaleLineComponent, ScaleLineModule, SelectionModeTypes, SelectionService, ToolbarComponent, ToolbarItemComponent, ToolbarItemComponentEvent, ToolbarItemDrawComponent, ToolbarItemDrawComponentEvent, ToolbarItemDrawType, ToolbarItemMeasureComponent, ToolbarItemMeasureComponentEvent, ToolbarItemMeasureType, ToolbarModule, VectorTileLayerComponent, WmsLayerComponent, WmtsLayerComponent, ZOOM_OPTIONS, ZoomLevelComponent, ZoomLevelModule, declusterFeatures, defs, epsg28992, extent, featureCollectionForLayerHasCluster, fromGeoJSONFeature, fromGeoJSONFeatures, matrixIds, matrixSizes, measureTypeToGeometryType, resolutions, toGeoJSONFeature };
